import { uniqueId } from 'lodash'
import React from 'react'
import { Type1Item } from '../components/addon/addons/parts/type1Class'
import { BoxClass } from './classes'
import { getIdForRenderTileInJSON } from '../components/list/window2/functions'
import { comboTextByOS } from './functions'
import { ImageClass } from '../components/addon/addons/parts/forEachInsertForm/imageHelp'

export const dummyTutorial = [
  {
    name: 'Basic',
    expanded: true,
    contents: [
      {
        name: 'Tutorial 1',
        checked: true
      },
      {
        name: 'Tutorial 2'
      },
      {
        name: 'Tutorial 3',
        checked: true
      }
    ]
  },
  {
    name: '아무거나 1',
    contents: [
      {
        name: 'Tutorial 1'
      },
      {
        name: 'Tutorial 2'
      },
      {
        name: 'Tutorial 3'
      }
    ]
  },
  {
    name: '아무거나 2',
    expanded: true,
    contents: [
      {
        name: 'Tutorial 1'
      },
      {
        name: 'Tutorial 2'
      },
      {
        name: 'Tutorial 3'
      }
    ]
  }
]

export const nodeDefaultSizeWithoutSubtitle = 27
export const nodeDefaultSizeWithSubtitle = nodeDefaultSizeWithoutSubtitle * 2

export const dummyData2 = [
  {
    title: '.gitignoredespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddd',
    subtitle: 'despised',
    id: 1,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: 'ddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddd',
    subtitle: '$ df ㄱㄴㄷ$',
    id: 2,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: 'src $ df  \\inta $',
    subtitle: '$ df  \\ $',
    id: 3,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true,
    children: [
      {
        title: '딴거좀',
        subtitle: 'ddddddddddddddddddddd',
        id: 4,
        get height () {
          return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
        },
        expanded: false,
        children: [
          {
            title: '해보자',
            subtitle: '예아',
            id: 6,
            get height () {
              return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
            },
            expanded: true
          },
          {
            title: '**bold**',
            subtitle: '',
            id: 5,
            get height () {
              return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
            },
            expanded: true
          },
          {
            title: '$$ df  \\int_x^y \\sum_x^y $$ <- $$',
            subtitle: '$ df  \\int_x^y \\sum_x^y $ <- $',
            id: 7,
            get height () {
              return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
            },
            expanded: true
          },
          {
            title: 'actions.js',
            subtitle: '',
            id: 8,
            get height () {
              return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
            },
            expanded: true
          },
          {
            title: 'utils.js',
            subtitle: 'despised',
            id: 9,
            get height () {
              return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
            },
            expanded: true
          }
        ]

      },
      {
        title: '# bold',
        subtitle: '',
        id: 11,
        get height () {
          return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
        },
        expanded: true
      },
      {
        title: '$$ df  \\int_x^y \\sum_x^y $$ <- $$',
        subtitle: '$ df  \\int_x^y \\sum_x^y $ <- $',
        id: 22,
        get height () {
          return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
        },
        expanded: true
      },
      {
        title: 'actions.js',
        subtitle: '',
        id: 33,
        get height () {
          return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
        },
        expanded: true
      },
      {
        title: 'utils.js',
        subtitle: 'despised',
        id: 44,
        get height () {
          return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
        },
        expanded: true
      }
    ]
  },
  {
    title: '**tmp**',
    subtitle: '',
    id: 55,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    children: [
      {
        title: '12214124-log',
        subtitle: 'despised',
        id: 66,
        get height () {
          return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
        }
      },
      {
        title: 'drag-disabled-file',
        subtitle: '',
        id: 77,
        get height () {
          return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
        }
      }
    ]
  },
  {
    title: 'build',
    subtitle: 'despised',
    id: 88,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    children: [{
      title: 'react-sortable-tree.js',
      subtitle: '',
      id: 99,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      }
    }]
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 111,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 222,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 333,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 444,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 555,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 666,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 777,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 888,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 999,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 1111,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 2222,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 3333,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 4444,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 5555,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 6666,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 7777,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 8888,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 9999,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 11111,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 22222,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 33333,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 44444,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 55555,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 66666,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 77777,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 88888,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 99999,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 111111,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 111112,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 111113,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 111114,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 111115,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 111116,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 111117,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 111118,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 111119,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 111121,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 111122,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 111123,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 111124,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 111125,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 111126,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 111127,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 111128,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 111129,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: uniqueId(),
    subtitle: uniqueId(),
    id: 111131,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
  },
  {
    title: 'node_modules',
    subtitle: 'despised',
    id: 111132,
    get height () {
      return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
    },
    expanded: true
    // height: (function () { return this.subtitle ? 52 : 26 }).bind(this)()
  }
]
if (process.env.NODE_ENV !== 'production') {
  const dummyData = [
    {
      title: '.gitignoredespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddddespiseddddddddddddddddddddd',
      subtitle: 'despised',
      id: 1,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: 'ddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddd',
      subtitle: '$ df ㄱㄴㄷ$',
      id: 2,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: 'src $ df  \\inta $',
      subtitle: '$ df  \\ $',
      id: 3,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true,
      children: [
        {
          title: 'ddddddddddddddddd\nddddddddddddddddddddddddddddd\na\nc\na',
          subtitle: 'ddddddddddddddddddddd',
          id: 4,
          get height () {
            return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
          },
          expanded: false,
          children: [
            {
              title: 'ddddddddddddddddd\nddddddddddddddddddddddddddddd\nb\nc\na',
              subtitle: 'ddddddddddddddddddddd',
              id: 6,
              get height () {
                return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
              },
              expanded: true
            },
            {
              title: '**bold**',
              subtitle: '',
              id: 5,
              get height () {
                return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
              },
              expanded: true
            },
            {
              title: '$$ df  \\int_x^y \\sum_x^y $$ <- $$',
              subtitle: '$ df  \\int_x^y \\sum_x^y $ <- $',
              id: 7,
              get height () {
                return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
              },
              expanded: true
            },
            {
              title: 'actions.js',
              subtitle: '',
              id: 8,
              get height () {
                return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
              },
              expanded: true
            },
            {
              title: 'utils.js',
              subtitle: 'despised',
              id: 9,
              get height () {
                return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
              },
              expanded: true
            }
          ]

        },
        {
          title: '# bold',
          subtitle: '',
          id: 11,
          get height () {
            return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
          },
          expanded: true
        },
        {
          title: '$$ df  \\int_x^y \\sum_x^y $$ <- $$',
          subtitle: '$ df  \\int_x^y \\sum_x^y $ <- $',
          id: 22,
          get height () {
            return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
          },
          expanded: true
        },
        {
          title: 'actions.js',
          subtitle: '',
          id: 33,
          get height () {
            return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
          },
          expanded: true
        },
        {
          title: 'utils.js',
          subtitle: 'despised',
          id: 44,
          get height () {
            return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
          },
          expanded: true
        }
      ]
    },
    {
      title: '**tmp**',
      subtitle: '',
      id: 55,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      children: [
        {
          title: '12214124-log',
          subtitle: 'despised',
          id: 66,
          get height () {
            return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
          }
        },
        {
          title: 'drag-disabled-file',
          subtitle: '',
          id: 77,
          get height () {
            return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
          },
          children: [
            {
              title: 'build',
              subtitle: 'despised',
              id: 88,
              get height () {
                return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
              },
              children: [{
                title: 'react-sortable-tree.js',
                subtitle: '',
                id: 99,
                get height () {
                  return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
                }
              }]
            }
          ]
        }
      ]
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 111,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 222,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 333,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 444,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 555,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 666,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 777,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 888,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 999,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 1111,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 2222,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 3333,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 4444,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 5555,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 6666,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 7777,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 8888,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 9999,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 11111,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 22222,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 33333,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 44444,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 55555,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 66666,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 77777,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 88888,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 99999,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 111111,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 111112,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 111113,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 111114,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 111115,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 111116,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 111117,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 111118,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 111119,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 111121,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 111122,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 111123,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 111124,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 111125,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 111126,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 111127,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 111128,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 111129,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: uniqueId(),
      subtitle: uniqueId(),
      id: 111131,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
    },
    {
      title: 'node_modules',
      subtitle: 'despised',
      id: 111132,
      get height () {
        return this.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle
      },
      expanded: true
      // height: (function () { return this.subtitle ? 52 : 26 }).bind(this)()
    }
  ]

  const DummyBoxContent = () => (<div>
    {uniqueId()}
    <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
    {uniqueId()}
  </div>)

  const dummyBoxes1 = []
  const dummyBoxes2 = []
  const dummyBoxes3 = []
  for (let i = 0; i < 15; i++) {
    dummyBoxes1.push(new BoxClass(DummyBoxContent, uniqueId(), null, 1, {}))
    dummyBoxes2.push(new BoxClass(DummyBoxContent, uniqueId(), null, 2, {}))
    dummyBoxes3.push(new BoxClass(DummyBoxContent, uniqueId(), null, 3, {}))
  }

  const dummyBoxes = {
    '1': dummyBoxes1,
    '2': dummyBoxes2,
    '3': dummyBoxes3
  }

  const dummyWindow2InitialValue = {
    direction: 'row',
    first: getIdForRenderTileInJSON(uniqueId(), [3, 4]),
    second: getIdForRenderTileInJSON(uniqueId(), [3, 4, 6])
  }

  const dummyChatMemoValue = 'ㄹㅇㄴㄹ<br>ㄴㅇㄴㅇ<br>ㄴ<br>ㄹㄴ<br>ㅇㄹㄴ<br>ㅇㄹ<br>ㅇㄴㄹ<br><br><hr><br><hr><br>ㅇㄴ<br>ㄹ<br>ㄴㄹ<br>ㄴ<br>ㄴㅇ<br>ㄹㄴ<br>ㄹ<br>ㅇㄴㄹ<br>ㄴㄹ<br>ㅇㄴㄹ<br>ㄴㄹ<br><h6>《 애플 》</h6><br>ㅇㄹ<br>ㅇㄴㄹ<br>ㄴ<br>ㄹㄴㅇ<br>ㄹㅇㄴ<br>ㄹㄴ<br>ㅇㄹ<br>ㅇㄴㄹ<br>ㅇㄴ<br>ㄹㅇㄴ<br>ㄹㅇㄴ<br>ㄹ<br>ㄹ<br>ㅇㄴ<br>'

  const getDummyType1Items = (count, location) => {
    // defer(() => {
    //   globalOnDemandVars[`set_CountForSample`](count)
    // })
    // return Array.from({ length: count }, (v, k) => k).map(k => (
    //   new Type1Item('Sample', 'item - ' + uniqueId(), `this is ${uniqueId()}`, 'Sample' + (k + 1), k + 1)))
  }

// const oneQoneA1 = new CardContents('필드가 non-nullable 한 표시', '!')
// const oneQoneA2 = new CardContents('Lorem ipsum dolor sit amet', 'query 문에서의 진입점')
// const oneQoneA3 = new CardContents('뮤테이션 타입', 'mutation 문에서의 진입점')
// const childrenWithOneDepth1 = new CardContents('진입점이라고 할 수 있는 특수한 두 타입', '쿼리와 뮤테이션', uniqueId(), [oneQoneA1])
// const childrenWithOneDepth2 = new CardContents('진입점이라고 할 수 있는 특수한 두 타입', '쿼리와 뮤테이션', uniqueId(), [oneQoneA1, oneQoneA2])
// const childrenWithOneDepth3 = new CardContents('진입점이라고 할 수 있는 특수한 두 타입', '쿼리와 뮤테이션', uniqueId(), [oneQoneA1, oneQoneA3, oneQoneA2])
// const childrenWithOneDepth4 = new CardContents('진입점이라고 할 수 있는 특수한 두 타입', null, uniqueId(), [oneQoneA1])
// const childrenWithOneDepth5 = new CardContents('진입점이라고 할 수 있는 특수한 두 타입', null, uniqueId(), [oneQoneA1, oneQoneA2])
// const childrenWithOneDepth6 = new CardContents('진입점이라고 할 수 있는 특수한 두 타입', null, uniqueId(), [oneQoneA1, oneQoneA3, oneQoneA2])
// const childrenWithTwoDepth1 = new CardContents('쿼리의 끝', '스칼라 타입', uniqueId(), [childrenWithOneDepth1])
// const childrenWithTwoDepth2 = new CardContents('쿼리의 끝', '스칼라 타입', uniqueId(), [childrenWithOneDepth1, childrenWithOneDepth2])
// const childrenWithTwoDepth3 = new CardContents('쿼리의 끝', '스칼라 타입', uniqueId(), [childrenWithOneDepth4])
// const childrenWithTwoDepth4 = new CardContents('쿼리의 끝', '스칼라 타입', uniqueId(), [childrenWithOneDepth4, childrenWithOneDepth3])
// const justContext5 = new CardContents('enum 타입', null, uniqueId(), [childrenWithOneDepth1, childrenWithOneDepth2])
// const justContext6 = new CardContents('enum 타입', null, uniqueId(), [childrenWithOneDepth4, childrenWithOneDepth3])
//
// export const dummyCards = [
//   // new Card('BackEnd', ['GraphQL', '스키마', '타입'], '객체타입', oneQoneA1, 'firstTime'),
//   // new Card('BackEnd', ['GraphQL', '스키마', '타입'], '객체타입', oneQoneA2),
//   // new Card('BackEnd', ['GraphQL', '스키마', '타입'], '객체타입', oneQoneA3, 'reStudy'),
//   new Card('BackEnd', ['GraphQL', '스키마', '타입'], '객체타입', [childrenWithOneDepth1, childrenWithOneDepth3]),
//   new Card('BackEnd', ['GraphQL', '스키마', '타입'], 'GraphQL', [childrenWithOneDepth2, childrenWithOneDepth3]),
//   new Card('BackEnd', ['GraphQL', '스키마', '타입'], '스키마', [childrenWithOneDepth3], 'reStudy'),
//   new Card('BackEnd', ['GraphQL', '스키마', '타입'], '4', [childrenWithOneDepth4]),
//   new Card('BackEnd', ['GraphQL', '스키마', '타입'], '5', [childrenWithOneDepth5], 'firstTime'),
//   new Card('BackEnd', ['GraphQL', '스키마', '타입'], '6', [childrenWithOneDepth6]),
//   new Card('BackEnd', ['GraphQL', '스키마', '타입'], '7', [childrenWithTwoDepth1]),
//   new Card('BackEnd', ['GraphQL', '스키마', '타입'], '8', [childrenWithTwoDepth2], 'firstTime'),
//   new Card('BackEnd', ['GraphQL', '스키마', '타입'], '9', [childrenWithTwoDepth3]),
//   new Card('BackEnd', ['GraphQL', '스키마', '타입'], '10', [childrenWithTwoDepth4]),
//   new Card('BackEnd', ['GraphQL', '스키마', '타입'], '11', [justContext5]),
//   new Card('BackEnd', ['GraphQL', '스키마', '타입'], '12', [justContext6])
//
// ]
}
export const dummyWindow2InitialValueForPixelMode = {
  direction: 'row',
  first: getIdForRenderTileInJSON(uniqueId(), [3]),
  second: getIdForRenderTileInJSON(uniqueId(), [3, 4])
}
const exampleMediaItemsBase = [
  {
    'type': 'LaTeX',
    'title': 'Example LaTeX',
    'content': '\\frac{\\int_a^b\\left(x+1\\right)\\text{d}x}{\\int_a^b\\left(x^2+x+1\\right)\\text{d}x}',
    'globalId': '19GRav1cAbq1tkdKGx7v',
    'countByType': 1,
    'ThumbNailForceUpdateObject': {},
    'setTitleForType1Item': null,
    'id': 'Example3'
  },
  {
    'type': 'Code',
    'title': 'Example Code',
    'content': 'if (something) {\n    something();\n} else {\n  somethingElse();\n}',
    'globalId': 'kWuNQ5taKcl3P3gp3BVW',
    'countByType': 2,
    'ThumbNailForceUpdateObject': {},
    'setTitleForType1Item': null,
    'id': 'Example2'
  },
  {
    'type': 'Drawing',
    'title': 'Example Drawing',
    'content': {
      'data': '{"lines":[{"points":[{"x":156,"y":71.65625},{"x":156,"y":71.65625},{"x":153,"y":70.65625},{"x":152,"y":71.65625},{"x":149,"y":71.65625},{"x":148,"y":71.65625},{"x":146,"y":71.65625},{"x":145,"y":71.65625},{"x":143,"y":71.65625},{"x":142,"y":71.65625},{"x":141,"y":71.65625},{"x":140,"y":71.65625},{"x":136,"y":72.65625},{"x":134,"y":72.65625},{"x":133,"y":73.65625},{"x":132,"y":73.65625},{"x":131,"y":73.65625},{"x":130,"y":73.65625},{"x":127,"y":73.65625},{"x":126,"y":73.65625},{"x":124,"y":74.65625},{"x":123,"y":74.65625},{"x":122,"y":75.65625},{"x":121,"y":76.65625},{"x":120,"y":76.65625},{"x":120,"y":77.65625},{"x":119,"y":77.65625},{"x":118,"y":77.65625},{"x":117,"y":77.65625},{"x":115,"y":79.65625},{"x":113,"y":79.65625},{"x":113,"y":80.65625},{"x":112,"y":80.65625},{"x":111,"y":80.65625},{"x":109,"y":82.65625},{"x":107,"y":82.65625},{"x":106,"y":83.65625},{"x":106,"y":84.65625},{"x":105,"y":84.65625},{"x":103,"y":85.65625},{"x":103,"y":86.65625},{"x":102,"y":86.65625},{"x":102,"y":87.65625},{"x":100,"y":88.65625},{"x":100,"y":89.65625},{"x":99,"y":89.65625},{"x":94,"y":94.65625},{"x":94,"y":95.65625},{"x":93,"y":95.65625},{"x":92,"y":95.65625},{"x":92,"y":96.65625},{"x":92,"y":97.65625},{"x":90,"y":98.65625},{"x":90,"y":99.65625},{"x":89,"y":100.65625},{"x":88,"y":100.65625},{"x":88,"y":101.65625},{"x":87,"y":102.65625},{"x":87,"y":103.65625},{"x":86,"y":105.65625},{"x":86,"y":106.65625},{"x":85,"y":107.65625},{"x":85,"y":109.65625},{"x":84,"y":111.65625},{"x":83,"y":111.65625},{"x":83,"y":112.65625},{"x":82,"y":115.65625},{"x":81,"y":115.65625},{"x":79,"y":118.65625},{"x":78,"y":120.65625},{"x":77,"y":121.65625},{"x":76,"y":123.65625},{"x":76,"y":124.65625},{"x":75,"y":127.65625},{"x":74,"y":128.65625},{"x":73,"y":130.65625},{"x":72,"y":131.65625},{"x":71,"y":133.65625},{"x":70,"y":134.65625},{"x":70,"y":136.65625},{"x":70,"y":137.65625},{"x":68,"y":139.65625},{"x":67,"y":139.65625},{"x":67,"y":140.65625},{"x":67,"y":141.65625},{"x":66,"y":142.65625},{"x":66,"y":143.65625},{"x":65,"y":145.65625},{"x":64,"y":146.65625},{"x":64,"y":147.65625},{"x":64,"y":148.65625},{"x":63,"y":149.65625},{"x":63,"y":152.65625},{"x":63,"y":153.65625},{"x":63,"y":154.65625},{"x":62,"y":155.65625},{"x":62,"y":159.65625},{"x":61,"y":160.65625},{"x":60,"y":164.65625},{"x":60,"y":167.65625},{"x":60,"y":169.65625},{"x":60,"y":171.65625},{"x":60,"y":172.65625},{"x":59,"y":175.65625},{"x":59,"y":176.65625},{"x":59,"y":178.65625},{"x":59,"y":179.65625},{"x":59,"y":183.65625},{"x":59,"y":184.65625},{"x":59,"y":189.65625},{"x":59,"y":191.65625},{"x":59,"y":193.65625},{"x":59,"y":194.65625},{"x":59,"y":197.65625},{"x":59,"y":198.65625},{"x":59,"y":200.65625},{"x":59,"y":201.65625},{"x":59,"y":206.65625},{"x":59,"y":207.65625},{"x":59,"y":208.65625},{"x":59,"y":209.65625},{"x":59,"y":210.65625},{"x":60,"y":212.65625},{"x":60,"y":213.65625},{"x":61,"y":215.65625},{"x":62,"y":218.65625},{"x":62,"y":220.65625},{"x":62,"y":221.65625},{"x":62,"y":224.65625},{"x":63,"y":226.65625},{"x":64,"y":229.65625},{"x":64,"y":230.65625},{"x":65,"y":233.65625},{"x":65,"y":234.65625},{"x":65,"y":236.65625},{"x":66,"y":238.65625},{"x":67,"y":239.65625},{"x":67,"y":240.65625},{"x":68,"y":244.65625},{"x":69,"y":246.65625},{"x":69,"y":248.65625},{"x":70,"y":248.65625},{"x":71,"y":250.65625},{"x":72,"y":252.65625},{"x":73,"y":253.65625},{"x":74,"y":254.65625},{"x":75,"y":255.65625},{"x":76,"y":257.65625},{"x":78,"y":258.65625},{"x":79,"y":259.65625},{"x":79,"y":260.65625},{"x":81,"y":263.65625},{"x":82,"y":264.65625},{"x":84,"y":265.65625},{"x":84,"y":266.65625},{"x":86,"y":267.65625},{"x":87,"y":269.65625},{"x":91,"y":272.65625},{"x":91,"y":273.65625},{"x":94,"y":276.65625},{"x":95,"y":276.65625},{"x":98,"y":279.65625},{"x":98,"y":280.65625},{"x":100,"y":281.65625},{"x":100,"y":282.65625},{"x":102,"y":284.65625},{"x":103,"y":284.65625},{"x":104,"y":285.65625},{"x":110,"y":288.65625},{"x":112,"y":291.65625},{"x":115,"y":293.65625},{"x":116,"y":293.65625},{"x":117,"y":293.65625},{"x":118,"y":294.65625},{"x":120,"y":295.65625},{"x":120,"y":296.65625},{"x":121,"y":296.65625},{"x":122,"y":296.65625},{"x":123,"y":296.65625},{"x":124,"y":296.65625},{"x":125,"y":296.65625},{"x":126,"y":297.65625},{"x":131,"y":298.65625},{"x":134,"y":298.65625},{"x":135,"y":298.65625},{"x":136,"y":298.65625},{"x":138,"y":298.65625},{"x":142,"y":299.65625},{"x":144,"y":299.65625},{"x":151,"y":299.65625},{"x":154,"y":299.65625},{"x":156,"y":299.65625},{"x":158,"y":299.65625},{"x":159,"y":300.65625},{"x":162,"y":300.65625},{"x":164,"y":300.65625},{"x":165,"y":300.65625},{"x":171,"y":302.65625},{"x":173,"y":302.65625},{"x":175,"y":302.65625},{"x":180,"y":302.65625},{"x":181,"y":302.65625},{"x":182,"y":302.65625},{"x":183,"y":302.65625},{"x":185,"y":302.65625},{"x":186,"y":302.65625},{"x":188,"y":302.65625},{"x":189,"y":302.65625},{"x":189,"y":303.65625},{"x":190,"y":304.65625},{"x":191,"y":307.65625},{"x":194,"y":308.65625},{"x":201,"y":311.65625},{"x":202,"y":311.65625},{"x":206,"y":311.65625},{"x":209,"y":311.65625},{"x":210,"y":310.65625},{"x":211,"y":310.65625},{"x":213,"y":310.65625},{"x":215,"y":310.65625},{"x":216,"y":310.65625},{"x":218,"y":311.65625},{"x":219,"y":311.65625},{"x":221,"y":311.65625},{"x":222,"y":311.65625},{"x":223,"y":311.65625},{"x":224,"y":311.65625},{"x":225,"y":311.65625},{"x":227,"y":311.65625},{"x":230,"y":311.65625},{"x":235,"y":311.65625},{"x":236,"y":311.65625},{"x":237,"y":311.65625},{"x":238,"y":311.65625},{"x":239,"y":311.65625},{"x":240,"y":311.65625},{"x":242,"y":311.65625},{"x":244,"y":311.65625},{"x":245,"y":311.65625},{"x":250,"y":310.65625},{"x":252,"y":309.65625},{"x":259,"y":309.65625},{"x":261,"y":309.65625},{"x":266,"y":309.65625},{"x":268,"y":309.65625},{"x":272,"y":308.65625},{"x":274,"y":308.65625},{"x":276,"y":307.65625},{"x":277,"y":307.65625},{"x":278,"y":307.65625},{"x":280,"y":307.65625},{"x":281,"y":307.65625},{"x":282,"y":306.65625},{"x":283,"y":305.65625},{"x":284,"y":305.65625},{"x":284,"y":304.65625},{"x":286,"y":303.65625},{"x":287,"y":303.65625},{"x":289,"y":302.65625},{"x":290,"y":302.65625},{"x":291,"y":301.65625},{"x":292,"y":300.65625},{"x":293,"y":299.65625},{"x":294,"y":298.65625},{"x":296,"y":297.65625},{"x":297,"y":297.65625},{"x":301,"y":294.65625},{"x":301,"y":293.65625},{"x":303,"y":293.65625},{"x":306,"y":291.65625},{"x":308,"y":289.65625},{"x":310,"y":289.65625},{"x":310,"y":288.65625},{"x":311,"y":287.65625},{"x":313,"y":286.65625},{"x":315,"y":285.65625},{"x":315,"y":284.65625},{"x":316,"y":284.65625},{"x":317,"y":283.65625},{"x":320,"y":281.65625},{"x":321,"y":279.65625},{"x":322,"y":278.65625},{"x":324,"y":278.65625},{"x":327,"y":275.65625},{"x":328,"y":274.65625},{"x":332,"y":271.65625},{"x":332,"y":270.65625},{"x":333,"y":268.65625},{"x":334,"y":267.65625},{"x":335,"y":264.65625},{"x":336,"y":263.65625},{"x":339,"y":260.65625},{"x":340,"y":259.65625},{"x":342,"y":257.65625},{"x":343,"y":256.65625},{"x":344,"y":255.65625},{"x":345,"y":254.65625},{"x":346,"y":254.65625},{"x":347,"y":252.65625},{"x":348,"y":251.65625},{"x":348,"y":250.65625},{"x":349,"y":248.65625},{"x":349,"y":245.65625},{"x":349,"y":243.65625},{"x":350,"y":238.65625},{"x":351,"y":236.65625},{"x":352,"y":233.65625},{"x":352,"y":232.65625},{"x":353,"y":226.65625},{"x":353,"y":224.65625},{"x":353,"y":221.65625},{"x":354,"y":219.65625},{"x":355,"y":214.65625},{"x":355,"y":212.65625},{"x":355,"y":211.65625},{"x":355,"y":209.65625},{"x":355,"y":208.65625},{"x":355,"y":203.65625},{"x":355,"y":202.65625},{"x":355,"y":201.65625},{"x":355,"y":200.65625},{"x":355,"y":196.65625},{"x":355,"y":194.65625},{"x":355,"y":192.65625},{"x":355,"y":188.65625},{"x":355,"y":185.65625},{"x":353,"y":180.65625},{"x":352,"y":175.65625},{"x":352,"y":171.65625},{"x":352,"y":168.65625},{"x":352,"y":167.65625},{"x":351,"y":166.65625},{"x":350,"y":164.65625},{"x":349,"y":160.65625},{"x":349,"y":159.65625},{"x":347,"y":155.65625},{"x":347,"y":154.65625},{"x":346,"y":151.65625},{"x":345,"y":150.65625},{"x":345,"y":148.65625},{"x":344,"y":146.65625},{"x":343,"y":142.65625},{"x":342,"y":141.65625},{"x":341,"y":136.65625},{"x":340,"y":133.65625},{"x":339,"y":131.65625},{"x":339,"y":129.65625},{"x":337,"y":125.65625},{"x":336,"y":123.65625},{"x":336,"y":122.65625},{"x":335,"y":122.65625},{"x":334,"y":120.65625},{"x":332,"y":119.65625},{"x":331,"y":117.65625},{"x":330,"y":117.65625},{"x":329,"y":116.65625},{"x":328,"y":115.65625},{"x":325,"y":114.65625},{"x":324,"y":113.65625},{"x":323,"y":112.65625},{"x":322,"y":111.65625},{"x":320,"y":110.65625},{"x":317,"y":108.65625},{"x":316,"y":107.65625},{"x":312,"y":104.65625},{"x":310,"y":103.65625},{"x":307,"y":101.65625},{"x":306,"y":100.65625},{"x":303,"y":98.65625},{"x":302,"y":97.65625},{"x":299,"y":94.65625},{"x":297,"y":91.65625},{"x":295,"y":90.65625},{"x":291,"y":87.65625},{"x":290,"y":86.65625},{"x":289,"y":85.65625},{"x":287,"y":84.65625},{"x":286,"y":83.65625},{"x":282,"y":81.65625},{"x":282,"y":79.65625},{"x":279,"y":78.65625},{"x":276,"y":77.65625},{"x":275,"y":76.65625},{"x":271,"y":75.65625},{"x":268,"y":74.65625},{"x":267,"y":73.65625},{"x":263,"y":72.65625},{"x":260,"y":71.65625},{"x":259,"y":70.65625},{"x":258,"y":70.65625},{"x":257,"y":70.65625},{"x":255,"y":69.65625},{"x":254,"y":69.65625},{"x":253,"y":68.65625},{"x":252,"y":68.65625},{"x":249,"y":67.65625},{"x":248,"y":67.65625},{"x":246,"y":67.65625},{"x":245,"y":67.65625},{"x":241,"y":67.65625},{"x":237,"y":66.65625},{"x":233,"y":66.65625},{"x":232,"y":66.65625},{"x":228,"y":65.65625},{"x":224,"y":64.65625},{"x":223,"y":64.65625},{"x":221,"y":64.65625},{"x":217,"y":64.65625},{"x":215,"y":64.65625},{"x":212,"y":64.65625},{"x":210,"y":64.65625},{"x":206,"y":64.65625},{"x":205,"y":64.65625},{"x":200,"y":64.65625},{"x":199,"y":64.65625},{"x":194,"y":64.65625},{"x":192,"y":64.65625},{"x":186,"y":64.65625},{"x":184,"y":64.65625},{"x":183,"y":64.65625},{"x":182,"y":64.65625},{"x":181,"y":64.65625},{"x":179,"y":64.65625},{"x":178,"y":64.65625},{"x":176,"y":64.65625},{"x":175,"y":64.65625},{"x":173,"y":64.65625},{"x":172,"y":64.65625},{"x":170,"y":64.65625},{"x":169,"y":64.65625},{"x":168,"y":64.65625},{"x":164,"y":64.65625},{"x":163,"y":64.65625},{"x":158,"y":64.65625},{"x":157,"y":64.65625},{"x":153,"y":64.65625},{"x":152,"y":64.65625},{"x":151,"y":64.65625},{"x":150,"y":64.65625},{"x":146,"y":64.65625},{"x":145,"y":64.65625},{"x":143,"y":64.65625},{"x":139,"y":64.65625},{"x":138,"y":64.65625},{"x":135,"y":64.65625},{"x":133,"y":64.65625},{"x":132,"y":64.65625}],"brushColor":"rgba(31, 1, 113, 1)","brushRadius":9},{"points":[{"x":156,"y":136.65625},{"x":156,"y":136.65625},{"x":156,"y":135.65625},{"x":156,"y":134.65625},{"x":156,"y":133.65625},{"x":156,"y":132.65625},{"x":155,"y":132.65625},{"x":154,"y":132.65625},{"x":153,"y":132.65625}],"brushColor":"rgba(31, 1, 113, 1)","brushRadius":9},{"points":[{"x":274,"y":148.65625},{"x":274,"y":148.65625}],"brushColor":"rgba(31, 1, 113, 1)","brushRadius":9},{"points":[{"x":124,"y":204.65625},{"x":124,"y":204.65625},{"x":125,"y":205.65625},{"x":126,"y":206.65625},{"x":127,"y":207.65625},{"x":128,"y":208.65625},{"x":129,"y":209.65625},{"x":130,"y":209.65625},{"x":132,"y":210.65625},{"x":135,"y":212.65625},{"x":136,"y":212.65625},{"x":137,"y":213.65625},{"x":138,"y":213.65625},{"x":139,"y":213.65625},{"x":140,"y":214.65625},{"x":141,"y":215.65625},{"x":142,"y":216.65625},{"x":143,"y":216.65625},{"x":145,"y":217.65625},{"x":146,"y":218.65625},{"x":148,"y":219.65625},{"x":149,"y":219.65625},{"x":151,"y":220.65625},{"x":152,"y":221.65625},{"x":152,"y":222.65625},{"x":154,"y":222.65625},{"x":156,"y":224.65625},{"x":157,"y":224.65625},{"x":158,"y":224.65625},{"x":160,"y":225.65625},{"x":161,"y":225.65625},{"x":163,"y":227.65625},{"x":164,"y":227.65625},{"x":165,"y":227.65625},{"x":166,"y":228.65625},{"x":167,"y":228.65625},{"x":169,"y":228.65625},{"x":169,"y":229.65625},{"x":172,"y":230.65625},{"x":175,"y":230.65625},{"x":177,"y":230.65625},{"x":178,"y":231.65625},{"x":179,"y":231.65625},{"x":179,"y":232.65625},{"x":180,"y":232.65625},{"x":181,"y":232.65625},{"x":183,"y":232.65625},{"x":185,"y":232.65625},{"x":186,"y":232.65625},{"x":187,"y":233.65625},{"x":188,"y":233.65625},{"x":189,"y":234.65625},{"x":190,"y":234.65625},{"x":191,"y":235.65625},{"x":192,"y":235.65625},{"x":193,"y":235.65625},{"x":194,"y":235.65625},{"x":195,"y":236.65625},{"x":196,"y":236.65625},{"x":197,"y":236.65625},{"x":199,"y":236.65625},{"x":202,"y":236.65625},{"x":203,"y":236.65625},{"x":204,"y":236.65625},{"x":206,"y":237.65625},{"x":207,"y":237.65625},{"x":208,"y":237.65625},{"x":209,"y":237.65625},{"x":210,"y":237.65625},{"x":211,"y":237.65625},{"x":214,"y":237.65625},{"x":215,"y":237.65625},{"x":217,"y":237.65625},{"x":218,"y":237.65625},{"x":220,"y":237.65625},{"x":222,"y":237.65625},{"x":223,"y":237.65625},{"x":224,"y":237.65625},{"x":226,"y":237.65625},{"x":227,"y":237.65625},{"x":229,"y":237.65625},{"x":230,"y":237.65625},{"x":232,"y":237.65625},{"x":232,"y":236.65625},{"x":235,"y":236.65625},{"x":236,"y":236.65625},{"x":238,"y":236.65625},{"x":239,"y":236.65625},{"x":240,"y":235.65625},{"x":241,"y":235.65625},{"x":243,"y":235.65625},{"x":245,"y":234.65625},{"x":246,"y":234.65625},{"x":246,"y":233.65625},{"x":247,"y":233.65625},{"x":248,"y":232.65625},{"x":249,"y":232.65625},{"x":250,"y":232.65625},{"x":252,"y":232.65625},{"x":253,"y":232.65625},{"x":255,"y":232.65625},{"x":256,"y":232.65625},{"x":257,"y":232.65625},{"x":258,"y":231.65625},{"x":259,"y":231.65625},{"x":260,"y":230.65625},{"x":261,"y":230.65625},{"x":263,"y":230.65625},{"x":264,"y":230.65625},{"x":265,"y":229.65625},{"x":266,"y":229.65625},{"x":266,"y":228.65625},{"x":267,"y":228.65625},{"x":269,"y":228.65625},{"x":270,"y":228.65625},{"x":271,"y":228.65625},{"x":272,"y":227.65625},{"x":274,"y":226.65625},{"x":275,"y":226.65625},{"x":276,"y":225.65625},{"x":277,"y":225.65625},{"x":278,"y":224.65625},{"x":279,"y":224.65625},{"x":280,"y":224.65625},{"x":280,"y":223.65625},{"x":281,"y":223.65625},{"x":282,"y":222.65625},{"x":283,"y":222.65625},{"x":284,"y":222.65625},{"x":284,"y":221.65625},{"x":285,"y":221.65625},{"x":286,"y":221.65625},{"x":287,"y":221.65625},{"x":287,"y":220.65625},{"x":288,"y":220.65625},{"x":289,"y":219.65625},{"x":290,"y":218.65625},{"x":290,"y":217.65625},{"x":291,"y":217.65625},{"x":292,"y":217.65625},{"x":293,"y":217.65625},{"x":293,"y":216.65625},{"x":293,"y":215.65625},{"x":294,"y":215.65625},{"x":294,"y":214.65625},{"x":295,"y":213.65625},{"x":296,"y":212.65625},{"x":296,"y":211.65625},{"x":297,"y":211.65625},{"x":297,"y":210.65625},{"x":298,"y":210.65625},{"x":299,"y":210.65625},{"x":300,"y":210.65625},{"x":300,"y":209.65625},{"x":301,"y":209.65625},{"x":303,"y":209.65625},{"x":303,"y":208.65625},{"x":304,"y":208.65625},{"x":304,"y":207.65625},{"x":305,"y":207.65625},{"x":305,"y":206.65625},{"x":306,"y":206.65625},{"x":306,"y":205.65625}],"brushColor":"rgba(31, 1, 113, 1)","brushRadius":9}],"width":400,"height":400}',
      'size': {
        'width': 400,
        'height': 400
      },
      'color': {
        'r': 31,
        'g': 1,
        'b': 113,
        'a': 1
      },
      'brushRadius': 9
    },
    'globalId': 'yCrQPRaCLoS0xDQI6hFT',
    'countByType': 2,
    'ThumbNailForceUpdateObject': {},
    'setTitleForType1Item': null,
    'id': 'Example1'
  }
]
export const exampleMediaItems = exampleMediaItemsBase.map((baseItem) => (
  new Type1Item(baseItem.type, baseItem.title, baseItem.content, baseItem.id, baseItem.countByType, null, false, false)
))

export const exampleValuesForSpreadsheet = {
  rows: [
    { description: 'Focus on an appropriate node', key: 'alt + enter', configForRow: { id: uniqueId() } },
    { description: 'Toggle visibility of child nodes', key: 'alt + /', configForRow: { id: uniqueId() } },
    { description: 'Move to this node', key: 'alt + right', configForRow: { id: uniqueId() } },
    { description: 'Open this node in new window', key: comboTextByOS('mod + alt + shift + right'), configForRow: { id: uniqueId() } },
    { description: 'Remove this node', key: comboTextByOS('mod + shift + backspace'), configForRow: { id: uniqueId() } },
    { description: 'You can insert medias like this', key: '![Example](1)', configForRow: { id: uniqueId() } },
    { description: '', key: '', configForRow: { id: uniqueId() } }
  ],
  columns: [ 'description', 'key' ],
  selectedItems1: ['description'],
  selectedItems2: ['key'],
  configForItems1: { description: { fontSize: 24 } },
  configForItems2: { key: { fontSize: 36 } }
}

export const exampleValuesForUploadType2 = {
  type: 'Image',
  title: 'Organs',
  switchForMultipleCard: true,
  inWaitingList: false,
  content: new ImageClass('organs.png', 'organs', 674, 599)
}
export const exampleValuesForUploadType22 = {
  type: 'Image',
  title: 'Trifle In Pyjamas lead sheet',
  switchForMultipleCard: true,
  inWaitingList: false,
  content: new ImageClass('Trifle_In_Pyjamas_lead_sheet.jpg', 'Trifle_In_Pyjamas_lead_sheet', 2488, 3221)
}

export const TreeDataFor1 = [
  {
    'id': 'qaXq9hw0TRlUbXz1wf2S',
    'height': 28,
    'editableValues': {
      'orderAsChild': 0,
      'difficulty': 0.3,
      'update': 7327,
      'interval': 1,
      'ratingRecord': [],
      'parentId': 'rootNode'
    },
    'expanded': true,
    'parentId': 'rootNode',
    'subtitle': '',
    'title': 'Numbers',
    'children': [
      {
        'id': '9Gamj0wU1pPhp55umCiy',
        'height': 56,

        'expanded': true,
        'parentId': 'qaXq9hw0TRlUbXz1wf2S',
        'subtitle': 'one',
        'title': '1',
        'doesIndexSwap': false
      },
      {
        'id': 'SLWEnf9tTfumihY8tS94',
        'height': 56,

        'expanded': true,
        'parentId': 'qaXq9hw0TRlUbXz1wf2S',
        'subtitle': 'two',
        'title': '2',
        'doesIndexSwap': false
      },
      {
        'id': 'J3WEEH4Up3rQ8U7WFbA9',
        'height': 56,

        'expanded': true,
        'parentId': 'qaXq9hw0TRlUbXz1wf2S',
        'subtitle': 'three',
        'title': '3',
        'doesIndexSwap': false
      },
      {
        'id': 'Eq8Ld8MLQMOkdbwmxKI8',
        'height': 56,

        'expanded': true,
        'parentId': 'qaXq9hw0TRlUbXz1wf2S',
        'subtitle': 'four',
        'title': '4',
        'doesIndexSwap': false
      },
      {
        'id': 'ZOrOYeSyVOGTPTCi4EYC',
        'height': 56,

        'expanded': true,
        'parentId': 'qaXq9hw0TRlUbXz1wf2S',
        'subtitle': 'five',
        'title': '5',
        'doesIndexSwap': false
      }
    ],
    'doesIndexSwap': false
  },
  {
    'id': 'u9N2s676DFVya1yFagv6',
    'height': 28,
    'editableValues': {
      'orderAsChild': 0.5,
      'difficulty': 0.3,
      'update': 7327,
      'interval': 1,
      'ratingRecord': [],
      'parentId': 'rootNode'
    },
    'expanded': true,
    'parentId': 'rootNode',
    'subtitle': '',
    'title': 'Basic',
    'children': [
      {
        'id': 'YZ8im1qEkDhX0JcbyGGK',
        'height': 56,

        'expanded': true,
        'parentId': 'u9N2s676DFVya1yFagv6',
        'subtitle': 'this is a node',
        'title': 'what is nodes',
        'children': [
          {
            'id': 'vGeL2D7QtVo6aeni0EqY',
            'height': 56,

            'expanded': true,
            'parentId': 'YZ8im1qEkDhX0JcbyGGK',
            'subtitle': 'It consists of a question part and an answer part',
            'title': 'composition',
            'children': [
              {
                'id': 'Ggq2uAvb9TK5shncnXuo',
                'height': 54,

                'expanded': true,
                'parentId': 'vGeL2D7QtVo6aeni0EqY',
                'subtitle': 'This is the answer part',
                'title': 'This is the question part'
              }
            ],
            'doesIndexSwap': false
          },
          {
            'id': '1HN9Y2qIVdFqZ9DkRWeD',
            'height': 28,

            'expanded': false,
            'parentId': 'YZ8im1qEkDhX0JcbyGGK',
            'subtitle': '',
            'title': 'Possible forms',
            'children': [
              {
                'id': 'qkp20Skp9aqNkQL9eh8u',
                'height': 56,

                'expanded': true,
                'parentId': '1HN9Y2qIVdFqZ9DkRWeD',
                'subtitle': 'like this node',
                'title': 'Basically a question-answer pair',
                'doesIndexSwap': false
              },
              {
                'id': '4WDsqbsTHt7sewkevuDY',
                'height': 28,

                'expanded': true,
                'parentId': '1HN9Y2qIVdFqZ9DkRWeD',
                'subtitle': '',
                'title': 'This is a context node',
                'children': [
                  {
                    'id': 'XhRPWfGRJXEgzyWIcWH6',
                    'height': 56,

                    'expanded': true,
                    'parentId': '4WDsqbsTHt7sewkevuDY',
                    'subtitle': 'If only the question part contains text, it is a context node',
                    'title': 'why?',
                    'doesIndexSwap': false
                  },
                  {
                    'id': 'VFt6GPRLlZsciL7UHWvt',
                    'height': 56,

                    'expanded': true,
                    'parentId': '4WDsqbsTHt7sewkevuDY',
                    'subtitle': 'It can subordinate other nodes',
                    'title': 'What is this for?',
                    'children': [
                      {
                        'id': 'LgETc40JnvtFplUJLg2J',
                        'height': 83,

                        'expanded': true,
                        'parentId': 'VFt6GPRLlZsciL7UHWvt',
                        'subtitle': 'like the parent node of this node',
                        'title': 'Actually, all nodes can subordinate others even if they are not context nodes',
                        'doesIndexSwap': false
                      }
                    ],
                    'doesIndexSwap': false
                  }
                ],
                'doesIndexSwap': false
              }
            ],
            'doesIndexSwap': false
          }
        ],
        'IntoParent': false,
        'doesIndexSwap': false
      },
      {
        'id': 'QYltbrWf7R6ITsJF9wrD',
        'height': 56,
        'editableValues': {
          'orderAsChild': 1,
          'difficulty': 0.3,
          'update': 7327,
          'interval': 1,
          'ratingRecord': [],
          'parentId': 'u9N2s676DFVya1yFagv6'
        },
        'expanded': true,
        'parentId': 'u9N2s676DFVya1yFagv6',
        'subtitle': '',
        'title': 'Media',
        'children': [
          {
            'id': 'pcAjzXFV1xPddRS6RlFT',
            'height': 28,

            'expanded': false,
            'parentId': 'QYltbrWf7R6ITsJF9wrD',
            'subtitle': '',
            'title': 'markdown',
            'children': [
              {
                'id': 'wPWsDAOyNn2XAT8EBt87',
                'height': 54,

                'expanded': true,
                'parentId': 'pcAjzXFV1xPddRS6RlFT',
                'subtitle': '**like this**',
                'title': 'bold'
              },
              {
                'id': 'wPWsDAOyNn2XAT8EBt55',
                'height': 54,

                'expanded': true,
                'parentId': 'pcAjzXFV1xPddRS6RlFT',
                'subtitle': '## like this',
                'title': 'big'
              },
              {
                'id': 'hf2oUBFOrU1l7yxnrjj8',
                'height': 54,

                'expanded': true,
                'parentId': 'pcAjzXFV1xPddRS6RlFT',
                'subtitle': '# like this',
                'title': 'bigger'
              },
              {
                'id': '4qPHaIxzh6zRpZ2KKcl7',
                'height': 54,

                'expanded': true,
                'parentId': 'pcAjzXFV1xPddRS6RlFT',
                'subtitle': '_like this_',
                'title': 'italic'
              },
              {
                'id': 'Tkf3BPyRHAO8zZaBbjgI',
                'height': 54,

                'expanded': true,
                'parentId': 'pcAjzXFV1xPddRS6RlFT',
                'subtitle': '~~like this~~',
                'title': 'Strikethrough'
              },
              {
                'id': 'BJZVUPAYDyn9CNUTkXQi',
                'height': 54,

                'expanded': true,
                'parentId': 'pcAjzXFV1xPddRS6RlFT',
                'subtitle': '-----',
                'title': 'line'
              },
              {
                'id': 'tcPn2M4aV9sPrKl1hCB6',
                'height': 27,

                'expanded': true,
                'parentId': 'pcAjzXFV1xPddRS6RlFT',
                'subtitle': '',
                'title': 'list',
                'children': [
                  {
                    'id': 'wynKczNjfTIccOUGL9G1',
                    'height': 54,

                    'expanded': true,
                    'parentId': 'tcPn2M4aV9sPrKl1hCB6',
                    'subtitle': '1. first\n2. second',
                    'title': 'ordered list'
                  },
                  {
                    'id': 'xaAUka4pGD1n862u9LES',
                    'height': 54,

                    'expanded': true,
                    'parentId': 'tcPn2M4aV9sPrKl1hCB6',
                    'subtitle': '* something\n* somethingelse',
                    'title': 'unordered list'
                  }
                ]
              }
            ],
            'doesIndexSwap': false
          },
          {
            'id': 'YABgk9qL3p3LJd0cDcdT',
            'height': 56,

            'expanded': true,
            'parentId': 'QYltbrWf7R6ITsJF9wrD',
            'subtitle': '![Example](1)',
            'title': 'drawing',
            'doesIndexSwap': false
          },
          {
            'id': 'qyath2PaJlGCA4tQ6L0h',
            'height': 28,

            'expanded': true,
            'parentId': 'QYltbrWf7R6ITsJF9wrD',
            'subtitle': '',
            'title': 'code',
            'children': [
              {
                'id': 'bBypAOBdo6ZVucNXXoWy',
                'height': 54,

                'expanded': true,
                'parentId': 'qyath2PaJlGCA4tQ6L0h',
                'subtitle': '`doSomething()`',
                'title': 'inline'
              },
              {
                'id': 'Hq5SkC0uFTMUFejsHkd6',
                'height': 54,

                'expanded': true,
                'parentId': 'qyath2PaJlGCA4tQ6L0h',
                'subtitle': '```\nif (something) {\n    doSomething();\n}\n```',
                'title': 'multiline'
              },
              {
                'id': 'K1jnYT6wycgcqyWIRmyp',
                'height': 54,

                'expanded': true,
                'parentId': 'qyath2PaJlGCA4tQ6L0h',
                'subtitle': '![Example](2)',
                'title': 'code block'
              }
            ],
            'doesIndexSwap': false
          },
          {
            'id': 'o5BMBVyvaZeIePGkpsdu',
            'height': 28,

            'expanded': true,
            'parentId': 'QYltbrWf7R6ITsJF9wrD',
            'subtitle': '',
            'title': 'LaTeX',
            'children': [
              {
                'id': 'skOFzt9aMmIjgW2yeEBY',
                'height': 54,

                'expanded': true,
                'parentId': 'o5BMBVyvaZeIePGkpsdu',
                'subtitle': '$\\int_a^b\\left(x+1\\right)\\text{d}x$',
                'title': 'inline'
              },
              {
                'id': 'abUgmZRoM75kPWtdp1g1',
                'height': 54,

                'expanded': true,
                'parentId': 'o5BMBVyvaZeIePGkpsdu',
                'subtitle': '![Example](3)',
                'title': 'LaTeX block'
              }
            ],
            'doesIndexSwap': false
          }
        ],
        'doesIndexSwap': false
      }
    ],
    'doesIndexSwap': false
  },
  {
    'id': 'w6t2oc4bdjOdR1QZgVqg',
    'height': 28,
    'editableValues': {
      'orderAsChild': 0.75,
      'difficulty': 0.3,
      'update': 7327,
      'interval': 1,
      'ratingRecord': [],
      'parentId': 'rootNode'
    },
    'expanded': true,
    'parentId': 'rootNode',
    'subtitle': '',
    'title': 'Some advice',
    'children': [
      {
        'id': 'dLPaRq0fkkmTuTn57gZl',
        'height': 112,

        'expanded': false,
        'parentId': 'w6t2oc4bdjOdR1QZgVqg',
        'subtitle': 'Maybe you want to try something, but you don\'t have anything to try at hand right now. Actually, I have no idea what to do in this case. Just to give you some initial advice, you don\'t need to try to build structures at first. It\'s good to just enter some tricky things to Memorize at first, and then let the structure naturally go up and down later.',
        'title': 'How to start',
        'children': [
          {
            'id': 'l8oAoyzfHvV8FC85bACr',
            'height': 28,

            'expanded': false,
            'parentId': 'dLPaRq0fkkmTuTn57gZl',
            'subtitle': '',
            'title': 'You can start like this',
            'children': [
              {
                'id': 'N14xn61hXS0KshIrNc0r',
                'height': 54,

                'expanded': true,
                'parentId': 'l8oAoyzfHvV8FC85bACr',
                'subtitle': '`*`',
                'title': 'no character or more than one character'
              },
              {
                'id': 'a8rWqtbhipb1zkIpPjGX',
                'height': 54,

                'expanded': true,
                'parentId': 'l8oAoyzfHvV8FC85bACr',
                'subtitle': '`+`',
                'title': 'more than one character'
              }
            ],
            'doesIndexSwap': false
          },
          {
            'id': 'KEhPYsvskhybOOJMvxPF',
            'height': 28,

            'expanded': false,
            'parentId': 'dLPaRq0fkkmTuTn57gZl',
            'subtitle': '',
            'title': 'And later you can let structure come up like this',
            'children': [
              {
                'id': 'F12y8WEc3lllR8NfyWem',
                'height': 27,

                'expanded': true,
                'parentId': 'KEhPYsvskhybOOJMvxPF',
                'subtitle': '',
                'title': 'Regular Expression',
                'children': [
                  {
                    'id': 'yMlequcd2Ejpl0fvpTym',
                    'height': 27,

                    'expanded': true,
                    'parentId': 'F12y8WEc3lllR8NfyWem',
                    'subtitle': '',
                    'title': 'quantifiers',
                    'children': [
                      {
                        'id': 'Qe2GxK3Lyo76W4b2v5ro',
                        'height': 54,

                        'expanded': true,
                        'parentId': 'yMlequcd2Ejpl0fvpTym',
                        'subtitle': '`*`',
                        'title': 'no characteer or more than one character',
                        'children': [
                          {
                            'id': 'EJ5hlaqZyRSgpzxficyh',
                            'height': 54,

                            'expanded': true,
                            'parentId': 'Qe2GxK3Lyo76W4b2v5ro',
                            'subtitle': '`*?`',
                            'title': 'lazy'
                          }
                        ]
                      },
                      {
                        'id': '8TnTOCSyD2a2p3kRd0Se',
                        'height': 54,

                        'expanded': true,
                        'parentId': 'yMlequcd2Ejpl0fvpTym',
                        'subtitle': '`+`',
                        'title': 'more than one character',
                        'children': [
                          {
                            'id': 'hvk06NGRwy310eI2bby8',
                            'height': 54,

                            'expanded': true,
                            'parentId': '8TnTOCSyD2a2p3kRd0Se',
                            'subtitle': '`+?`',
                            'title': 'lazy'
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            'doesIndexSwap': false
          }
        ],
        'doesIndexSwap': false
      },
      {
        'id': 'BYa2iTrwo8I9EhrFgc5u',
        'height': 83,

        'expanded': true,
        'parentId': 'w6t2oc4bdjOdR1QZgVqg',
        'subtitle': 'You can use ChatMemo anywhere in the app with alt + q. This is useful. I recommend that you use it as a habit.',
        'title': 'ChatMemo',
        'doesIndexSwap': false
      },
      {
        'id': '5nSwz8KkcFxlqfs1n1LE',
        'height': 112,

        'expanded': true,
        'parentId': 'w6t2oc4bdjOdR1QZgVqg',
        'subtitle': 'I don\'t think so. Rather, I think the idea that the state of having knowledge on a subject can be toggled as needed is good. And LearnObit\'s tree structure helps you learn by flexibly choosing only some part of the overall content. On the other hand, in conventional Spaced Repetition Software, when the learning is delayed for several months, the flashcards become unmanageable.',
        'title': 'Does one have to do the \'Memorizing\' part on a daily basis?',
        'doesIndexSwap': false
      }
    ],
    'doesIndexSwap': false
  }
]
export const MosaicFor1 = {
  'first': '{"id":"_1yDSU7t","path":["u9N2s676DFVya1yFagv6","YZ8im1qEkDhX0JcbyGGK"]}',
  'second': {
    'first': '{"id":"bBbR3G6T","path":["u9N2s676DFVya1yFagv6","QYltbrWf7R6ITsJF9wrD"]}',
    'second': {
      'first': '{"id":"ndz3FbEK","path":["w6t2oc4bdjOdR1QZgVqg"]}',
      'second': '{"id":"TKiYp7x6","path":["qaXq9hw0TRlUbXz1wf2S"]}',
      'direction': 'row'
    },
    'direction': 'column'
  },
  'direction': 'row'
}

export const TreeDataFor2 = (
  [
    {
      'id': 'T8KREjHl6aAl1IEOiIct',
      'height': 28,

      'expanded': false,
      'parentId': 'rootNode',
      'subtitle': '',
      'title': 'Programming',
      'children': [
        {
          'id': 'zSrhu9jHBifl1SUbtzCk',
          'height': 27,

          'expanded': true,
          'parentId': 'T8KREjHl6aAl1IEOiIct',
          'subtitle': '',
          'title': 'Regular Expression',
          'children': [
            {
              'id': 'ZvbNchx1IPb9FxEReSGh',
              'height': 54,
              'editableValues': {
                'failStatus': 'solved',
                'orderAsChild': 0,
                'difficulty': 0.4529411764705883,
                'update': 7326,
                'interval': 4,
                'ratingRecord': [
                  {
                    'rating': 'hard',
                    'time': 1579702452685
                  },
                  {
                    'rating': 'hard',
                    'time': 1579702896275
                  }
                ]
              },
              'expanded': true,
              'parentId': 'zSrhu9jHBifl1SUbtzCk',
              'subtitle': '1. match\n2. replace',
              'title': 'When do you need this?'
            },
            {
              'id': '9qdNmw6rVral84wYyUrE',
              'height': 27,

              'expanded': true,
              'parentId': 'zSrhu9jHBifl1SUbtzCk',
              'subtitle': '',
              'title': 'grammar',
              'children': [
                {
                  'id': 't9Lft1OXbKVw3oUsIxlZ',
                  'height': 27,

                  'expanded': true,
                  'parentId': '9qdNmw6rVral84wYyUrE',
                  'subtitle': '',
                  'title': 'quantifier',
                  'children': [
                    {
                      'id': 'xL4UQbO1rAdCTAEvbPq0',
                      'height': 54,
                      'editableValues': {
                        'failStatus': 'solved',
                        'orderAsChild': 0,
                        'difficulty': 0.4529411764705883,
                        'update': 7329,
                        'interval': 4,
                        'ratingRecord': [
                          {
                            'rating': 'hard',
                            'time': 1579766884722
                          },
                          {
                            'rating': 'hard',
                            'time': 1579767109558
                          },
                          {
                            'rating': 'normal',
                            'time': 1579906062659
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': 't9Lft1OXbKVw3oUsIxlZ',
                      'subtitle': 'Find the largest chunk as possible',
                      'title': 'greedy',
                      'children': [
                        {
                          'id': 'wrAtN4v4Cn4VXUqTVmjZ',
                          'height': 54,
                          'editableValues': {
                            'failStatus': 'solved',
                            'orderAsChild': 0,
                            'difficulty': 0.4529411764705883,
                            'update': 7329,
                            'interval': 4,
                            'ratingRecord': [
                              {
                                'rating': 'hard',
                                'time': 1579716435247
                              },
                              {
                                'rating': 'hard',
                                'time': 1579766894087
                              },
                              {
                                'rating': 'normal',
                                'time': 1579906084772
                              }
                            ]
                          },
                          'expanded': true,
                          'parentId': 'xL4UQbO1rAdCTAEvbPq0',
                          'subtitle': 'default',
                          'title': 'how to set'
                        }
                      ]
                    },
                    {
                      'id': 'J48xQNLTLYcrmDPRvlA0',
                      'height': 54,
                      'editableValues': {
                        'failStatus': 'solved',
                        'orderAsChild': 1,
                        'difficulty': 0.4529411764705883,
                        'update': 7329,
                        'interval': 4,
                        'ratingRecord': [
                          {
                            'rating': 'hard',
                            'time': 1579766890434
                          },
                          {
                            'rating': 'hard',
                            'time': 1579767109563
                          },
                          {
                            'rating': 'normal',
                            'time': 1579906068593
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': 't9Lft1OXbKVw3oUsIxlZ',
                      'subtitle': 'Find the minimum chunk that matchs',
                      'title': 'lazy',
                      'children': [
                        {
                          'id': 'VZyNuLat3q3NyZmadNGs',
                          'height': 54,
                          'expanded': true,
                          'parentId': 'J48xQNLTLYcrmDPRvlA0',
                          'subtitle': 'append ? after quantifier',
                          'title': 'how to set'
                        }
                      ]
                    }
                  ]
                },
                {
                  'id': 'PyQE6uuuOCqi8tL3BqFw',
                  'height': 27,

                  'expanded': true,
                  'parentId': '9qdNmw6rVral84wYyUrE',
                  'subtitle': '',
                  'title': 'multiline',
                  'children': [
                    {
                      'id': 'I0ZgaO2hThFrizppp1cS',
                      'height': 54,
                      'expanded': true,
                      'parentId': 'PyQE6uuuOCqi8tL3BqFw',
                      'subtitle': 'Recognize newline characters as delimiters',
                      'title': 'effect',
                      'children': [
                        {
                          'id': 'ZmYwqTiNar5fD4hU682e',
                          'height': 54,
                          'expanded': true,
                          'parentId': 'I0ZgaO2hThFrizppp1cS',
                          'subtitle': 'Also matches the beginning of a string following a line break',
                          'title': '^'
                        },
                        {
                          'id': '6rmNyD3c0gEAlKQaZUT2',
                          'height': 54,
                          'expanded': true,
                          'parentId': 'I0ZgaO2hThFrizppp1cS',
                          'subtitle': 'Also matches the end of a string following a line break',
                          'title': '$'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              'id': '4NUhqfwL0QRME2TLjGfO',
              'height': 27,

              'expanded': true,
              'parentId': 'zSrhu9jHBifl1SUbtzCk',
              'subtitle': '',
              'title': 'in javascript',
              'children': [
                {
                  'id': 'JyGZq4eh0Y6v9DcByA6y',
                  'height': 27,

                  'expanded': true,
                  'parentId': '4NUhqfwL0QRME2TLjGfO',
                  'subtitle': '',
                  'title': 'flag',
                  'children': [
                    {
                      'id': '58xS0kj61j7vGBMuuTpz',
                      'height': 54,
                      'editableValues': {
                        'orderAsChild': 0,
                        'difficulty': 0.24117647058823527,
                        'update': 7327,
                        'interval': 3,
                        'ratingRecord': [
                          {
                            'rating': 'easy',
                            'time': 1579766965598
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': 'JyGZq4eh0Y6v9DcByA6y',
                      'subtitle': 'g',
                      'title': 'global'
                    },
                    {
                      'id': 'gwA7BJOvuLF6tb7MRm4i',
                      'height': 54,
                      'editableValues': {
                        'orderAsChild': 1,
                        'difficulty': 0.24117647058823527,
                        'update': 7327,
                        'interval': 3,
                        'ratingRecord': [
                          {
                            'rating': 'easy',
                            'time': 1579766965600
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': 'JyGZq4eh0Y6v9DcByA6y',
                      'subtitle': 'i',
                      'title': 'Case insensitivity'
                    },
                    {
                      'id': 'J5NNMlmi8HKveBYdO3XC',
                      'height': 54,
                      'editableValues': {
                        'failStatus': 'solved',
                        'orderAsChild': 2,
                        'difficulty': 0.4529411764705883,
                        'update': 7327,
                        'interval': 2,
                        'ratingRecord': [
                          {
                            'rating': 'hard',
                            'time': 1579767187998
                          },
                          {
                            'rating': 'hard',
                            'time': 1579767382210
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': 'JyGZq4eh0Y6v9DcByA6y',
                      'subtitle': 'm',
                      'title': 'multiline'
                    }
                  ]
                },
                {
                  'id': '80i7nFjpvYLTAaLP0YeM',
                  'height': 27,

                  'expanded': true,
                  'parentId': '4NUhqfwL0QRME2TLjGfO',
                  'subtitle': '',
                  'title': 'method',
                  'children': [
                    {
                      'id': 'O47W1rkcLLNutGVMHlMS',
                      'height': 54,
                      'editableValues': {
                        'failStatus': 'solved',
                        'orderAsChild': 0,
                        'difficulty': 0.7705882352941176,
                        'update': 7327,
                        'interval': 1,
                        'ratingRecord': [
                          {
                            'rating': 'fail',
                            'time': 1579767011333
                          },
                          {
                            'rating': 'hard',
                            'time': 1579767401971
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': '80i7nFjpvYLTAaLP0YeM',
                      'subtitle': 'RegEx.prototype.test()',
                      'title': 'Check for string-matching parts'
                    },
                    {
                      'id': 'elKBuUbPr1i2b1CLUjex',
                      'height': 54,
                      'editableValues': {
                        'failStatus': 'solved',
                        'orderAsChild': 1,
                        'difficulty': 0.7705882352941176,
                        'update': 7327,
                        'interval': 1,
                        'ratingRecord': [
                          {
                            'rating': 'fail',
                            'time': 1579767011375
                          },
                          {
                            'rating': 'hard',
                            'time': 1579767401992
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': '80i7nFjpvYLTAaLP0YeM',
                      'subtitle': 'String.prototype.replace()',
                      'title': 'replace'
                    },
                    {
                      'id': '66KdRUhcdQnv0sjzxM0P',
                      'height': 54,
                      'editableValues': {
                        'failStatus': 'solved',
                        'orderAsChild': 2,
                        'difficulty': 0.7705882352941176,
                        'update': 7327,
                        'interval': 1,
                        'ratingRecord': [
                          {
                            'rating': 'fail',
                            'time': 1579767235029
                          },
                          {
                            'rating': 'hard',
                            'time': 1579767431174
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': '80i7nFjpvYLTAaLP0YeM',
                      'subtitle': 'String.prototype.split()',
                      'title': 'Split a string into several'
                    }
                  ]
                }
              ]
            },
            {
              'id': 'ylcErEplbNYEftPehNch',
              'height': 27,

              'expanded': true,
              'parentId': 'zSrhu9jHBifl1SUbtzCk',
              'subtitle': '',
              'title': 'characters',
              'children': [
                {
                  'id': 'MGMYuWMnDhO8gO059b6G',
                  'height': 27,

                  'expanded': true,
                  'parentId': 'ylcErEplbNYEftPehNch',
                  'subtitle': '',
                  'title': 'specific characters',
                  'children': [
                    {
                      'id': 'fuQtxl6vlnhykO1fTTQz',
                      'height': 56,
                      'editableValues': {
                        'failStatus': 'solved',
                        'orderAsChild': -1,
                        'difficulty': 0.4529411764705883,
                        'update': 7326,
                        'interval': 4,
                        'ratingRecord': [
                          {
                            'rating': 'hard',
                            'time': 1579702537028
                          },
                          {
                            'rating': 'hard',
                            'time': 1579702896301
                          }
                        ],
                        'parentId': 'MGMYuWMnDhO8gO059b6G'
                      },
                      'expanded': true,
                      'parentId': 'LftyZLpg2afyRArlq2aE',
                      'subtitle': '\\d',
                      'title': 'every numbers',
                      'children': [
                        {
                          'id': 'WpJGMwaxo8m3no4cbMCy',
                          'height': 56,
                          'editableValues': {
                            'failStatus': 'solved',
                            'orderAsChild': 0,
                            'difficulty': 0.4529411764705883,
                            'update': 7326,
                            'interval': 4,
                            'ratingRecord': [
                              {
                                'rating': 'hard',
                                'time': 1579703076686
                              },
                              {
                                'rating': 'hard',
                                'time': 1579703215023
                              }
                            ]
                          },
                          'expanded': true,
                          'parentId': 'fuQtxl6vlnhykO1fTTQz',
                          'subtitle': '\\D',
                          'title': 'revers',
                          'doesIndexSwap': false
                        }
                      ],
                      'doesIndexSwap': false
                    },
                    {
                      'id': 'nFgQCsppEn6eNC5PeHef',
                      'height': 56,
                      'editableValues': {
                        'failStatus': 'solved',
                        'orderAsChild': 1,
                        'difficulty': 0.4529411764705883,
                        'update': 7326,
                        'interval': 4,
                        'ratingRecord': [
                          {
                            'rating': 'hard',
                            'time': 1579702681702
                          },
                          {
                            'rating': 'hard',
                            'time': 1579702896319
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': 'MGMYuWMnDhO8gO059b6G',
                      'subtitle': '\\w',
                      'title': 'every numbers and english characters and underline',
                      'children': [
                        {
                          'id': 'ebK0naMF8LL6IvDsQPnT',
                          'height': 56,
                          'editableValues': {
                            'failStatus': 'solved',
                            'orderAsChild': 0,
                            'difficulty': 0.4529411764705883,
                            'update': 7326,
                            'interval': 4,
                            'ratingRecord': [
                              {
                                'rating': 'hard',
                                'time': 1579703097309
                              },
                              {
                                'rating': 'hard',
                                'time': 1579703228910
                              }
                            ]
                          },
                          'expanded': true,
                          'parentId': 'nFgQCsppEn6eNC5PeHef',
                          'subtitle': '\\W',
                          'title': 'reverse',
                          'doesIndexSwap': false
                        }
                      ],
                      'doesIndexSwap': false
                    }
                  ],
                  'IntoParent': false
                },
                {
                  'id': 'pB4oekYBGmclmS3z6bOd',
                  'height': 27,

                  'expanded': true,
                  'parentId': 'ylcErEplbNYEftPehNch',
                  'subtitle': '',
                  'title': 'meta',
                  'children': [
                    {
                      'id': 'ZjpH1K2gPALxxsfDUTju',
                      'height': 54,
                      'editableValues': {
                        'orderAsChild': 0,
                        'difficulty': 0.24117647058823527,
                        'update': 7326,
                        'interval': 4,
                        'ratingRecord': [
                          {
                            'rating': 'easy',
                            'time': 1579702704034
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': 'pB4oekYBGmclmS3z6bOd',
                      'subtitle': '.',
                      'title': 'Matches any character'
                    },
                    {
                      'id': '8dFrebhGWyKElBiBQ89z',
                      'height': 54,
                      'editableValues': {
                        'orderAsChild': 1,
                        'difficulty': 0.24117647058823527,
                        'update': 7326,
                        'interval': 4,
                        'ratingRecord': [
                          {
                            'rating': 'easy',
                            'time': 1579702713690
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': 'pB4oekYBGmclmS3z6bOd',
                      'subtitle': '|',
                      'title': 'match to right or left',
                      'children': [
                        {
                          'id': '5dbLIHgnT8TSJ0UiOghN',
                          'height': 54,
                          'editableValues': {
                            'failStatus': 'solved',
                            'orderAsChild': 0,
                            'difficulty': 0.4529411764705883,
                            'update': 7327,
                            'interval': 2,
                            'ratingRecord': [
                              {
                                'rating': 'hard',
                                'time': 1579716390003
                              },
                              {
                                'rating': 'hard',
                                'time': 1579766874602
                              }
                            ]
                          },
                          'expanded': true,
                          'parentId': '8dFrebhGWyKElBiBQ89z',
                          'subtitle': 'Starting from the left, if the pattern on the left matches, the pattern on the right is ignored.',
                          'title': 'order'
                        }
                      ]
                    },
                    {
                      'id': 'Th4Uk8kim3chDeSCYBBo',
                      'height': 54,
                      'editableValues': {
                        'orderAsChild': 2,
                        'difficulty': 0.24117647058823527,
                        'update': 7326,
                        'interval': 4,
                        'ratingRecord': [
                          {
                            'rating': 'easy',
                            'time': 1579702803653
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': 'pB4oekYBGmclmS3z6bOd',
                      'subtitle': '[]',
                      'title': 'match to one of group'
                    },
                    {
                      'id': '3Z0iEohSUT2K7yOW9MvP',
                      'height': 54,
                      'editableValues': {
                        'orderAsChild': 3,
                        'difficulty': 0.24117647058823527,
                        'update': 7326,
                        'interval': 4,
                        'ratingRecord': [
                          {
                            'rating': 'easy',
                            'time': 1579702814754
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': 'pB4oekYBGmclmS3z6bOd',
                      'subtitle': '[^]',
                      'title': 'match to all except for group members'
                    },
                    {
                      'id': 'aNc1jgBuDpylvQeAHZyc',
                      'height': 54,
                      'editableValues': {
                        'orderAsChild': 4,
                        'difficulty': 0.24117647058823527,
                        'update': 7326,
                        'interval': 4,
                        'ratingRecord': [
                          {
                            'rating': 'easy',
                            'time': 1579702818006
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': 'pB4oekYBGmclmS3z6bOd',
                      'subtitle': '-',
                      'title': 'scope',
                      'children': [
                        {
                          'id': 'CaD8h1E1ZXUGQwi5lTFN',
                          'height': 54,
                          'editableValues': {
                            'orderAsChild': 0,
                            'difficulty': 0.24117647058823527,
                            'update': 7326,
                            'interval': 4,
                            'ratingRecord': [
                              {
                                'rating': 'easy',
                                'time': 1579702829159
                              }
                            ]
                          },
                          'expanded': true,
                          'parentId': 'aNc1jgBuDpylvQeAHZyc',
                          'subtitle': 'English uppercase, lowercase, and numbers',
                          'title': 'Target of use'
                        }
                      ]
                    },
                    {
                      'id': 'GKnD9hvBPPj5etDTHyAF',
                      'height': 54,
                      'editableValues': {
                        'orderAsChild': 5,
                        'difficulty': 0.24117647058823527,
                        'update': 7326,
                        'interval': 4,
                        'ratingRecord': [
                          {
                            'rating': 'easy',
                            'time': 1579702823223
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': 'pB4oekYBGmclmS3z6bOd',
                      'subtitle': '\\',
                      'title': 'escape',
                      'children': [
                        {
                          'id': 'woCgvm7K3Qs3xc2V73VX',
                          'height': 54,
                          'editableValues': {
                            'orderAsChild': 0,
                            'difficulty': 0.24117647058823527,
                            'update': 7326,
                            'interval': 4,
                            'ratingRecord': [
                              {
                                'rating': 'easy',
                                'time': 1579702830998
                              }
                            ]
                          },
                          'expanded': true,
                          'parentId': 'GKnD9hvBPPj5etDTHyAF',
                          'subtitle': 'To match metacharacters with plain characters',
                          'title': 'Why use it?'
                        }
                      ]
                    }
                  ]
                },
                {
                  'id': 'RxHupxayAf6KiD4zdrR6',
                  'height': 27,

                  'expanded': true,
                  'parentId': 'ylcErEplbNYEftPehNch',
                  'subtitle': '',
                  'title': 'quantifiers',
                  'children': [
                    {
                      'id': 'GwvGrJyBkwGKVGxBi0mK',
                      'height': 54,
                      'editableValues': {
                        'orderAsChild': 0,
                        'difficulty': 0.24117647058823527,
                        'update': 7326,
                        'interval': 4,
                        'ratingRecord': [
                          {
                            'rating': 'easy',
                            'time': 1579702839097
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': 'RxHupxayAf6KiD4zdrR6',
                      'subtitle': '*',
                      'title': 'no characteer or more than one character',
                      'children': [
                        {
                          'id': 'JC66kFyvv9V37BquQPjo',
                          'height': 54,
                          'editableValues': {
                            'failStatus': 'solved',
                            'orderAsChild': 0,
                            'difficulty': 0.4529411764705883,
                            'update': 7326,
                            'interval': 4,
                            'ratingRecord': [
                              {
                                'rating': 'hard',
                                'time': 1579702966547
                              },
                              {
                                'rating': 'hard',
                                'time': 1579703259718
                              }
                            ]
                          },
                          'expanded': true,
                          'parentId': 'GwvGrJyBkwGKVGxBi0mK',
                          'subtitle': '*?',
                          'title': 'lazy'
                        }
                      ]
                    },
                    {
                      'id': '96MMslkIlEMmRjMw73MF',
                      'height': 54,
                      'editableValues': {
                        'failStatus': 'solved',
                        'orderAsChild': 1,
                        'difficulty': 0.4529411764705883,
                        'update': 7326,
                        'interval': 4,
                        'ratingRecord': [
                          {
                            'rating': 'hard',
                            'time': 1579702868796
                          },
                          {
                            'rating': 'hard',
                            'time': 1579703020022
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': 'RxHupxayAf6KiD4zdrR6',
                      'subtitle': '+',
                      'title': 'more than one character',
                      'children': [
                        {
                          'id': 'T29yF9tmRnS2RVPWFd0A',
                          'height': 54,
                          'editableValues': {
                            'failStatus': 'solved',
                            'orderAsChild': 0,
                            'difficulty': 0.4529411764705883,
                            'update': 7326,
                            'interval': 4,
                            'ratingRecord': [
                              {
                                'rating': 'hard',
                                'time': 1579702966753
                              },
                              {
                                'rating': 'hard',
                                'time': 1579703259940
                              }
                            ]
                          },
                          'expanded': true,
                          'parentId': '96MMslkIlEMmRjMw73MF',
                          'subtitle': '+?',
                          'title': 'lazy'
                        }
                      ]
                    },
                    {
                      'id': 'qqLkVBt1ykcmLcfH78to',
                      'height': 54,
                      'editableValues': {
                        'failStatus': 'solved',
                        'orderAsChild': 2,
                        'difficulty': 0.4529411764705883,
                        'update': 7326,
                        'interval': 4,
                        'ratingRecord': [
                          {
                            'rating': 'hard',
                            'time': 1579702868897
                          },
                          {
                            'rating': 'hard',
                            'time': 1579703405417
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': 'RxHupxayAf6KiD4zdrR6',
                      'subtitle': '?',
                      'title': 'no character or one character'
                    },
                    {
                      'id': '403lCAKjlvCr0ErLPGDq',
                      'height': 54,
                      'editableValues': {
                        'orderAsChild': 3,
                        'difficulty': 0.24117647058823527,
                        'update': 7326,
                        'interval': 4,
                        'ratingRecord': [
                          {
                            'rating': 'easy',
                            'time': 1579702933209
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': 'RxHupxayAf6KiD4zdrR6',
                      'subtitle': '{n}',
                      'title': 'exactly match n times'
                    },
                    {
                      'id': 'EzEYCeIBAgwBtPvdj94I',
                      'height': 54,
                      'editableValues': {
                        'orderAsChild': 3.75,
                        'difficulty': 0.24117647058823527,
                        'update': 7326,
                        'interval': 4,
                        'ratingRecord': [
                          {
                            'rating': 'easy',
                            'time': 1579702933269
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': 'RxHupxayAf6KiD4zdrR6',
                      'subtitle': '{n,}',
                      'title': 'match more than n times',
                      'children': [
                        {
                          'id': 'qI4GOy7VC8NCTdtlDwXa',
                          'height': 54,
                          'editableValues': {
                            'failStatus': 'solved',
                            'orderAsChild': 0,
                            'difficulty': 0.4529411764705883,
                            'update': 7326,
                            'interval': 4,
                            'ratingRecord': [
                              {
                                'rating': 'hard',
                                'time': 1579702966918
                              },
                              {
                                'rating': 'hard',
                                'time': 1579703378010
                              }
                            ]
                          },
                          'expanded': true,
                          'parentId': 'EzEYCeIBAgwBtPvdj94I',
                          'subtitle': '{n,}?',
                          'title': 'lazy'
                        }
                      ]
                    },
                    {
                      'id': 'UVEeWEbsiTbbqavbKscn',
                      'height': 54,
                      'editableValues': {
                        'orderAsChild': 4,
                        'difficulty': 0.24117647058823527,
                        'update': 7326,
                        'interval': 4,
                        'ratingRecord': [
                          {
                            'rating': 'easy',
                            'time': 1579702933245
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': 'RxHupxayAf6KiD4zdrR6',
                      'subtitle': '{m, n}',
                      'title': 'match from m times to n times'
                    }
                  ]
                },
                {
                  'id': 'PsS20JjvPNaYFjTrQAyL',
                  'height': 27,

                  'expanded': true,
                  'parentId': 'ylcErEplbNYEftPehNch',
                  'subtitle': '',
                  'title': 'position matching',
                  'children': [
                    {
                      'id': 'ZH7YfWSq1WOxsxQ1ensV',
                      'height': 27,

                      'expanded': true,
                      'parentId': 'PsS20JjvPNaYFjTrQAyL',
                      'subtitle': '',
                      'title': 'characters',
                      'children': [
                        {
                          'id': 'maSmdW3no9eWedTxtHbM',
                          'height': 54,
                          'editableValues': {
                            'orderAsChild': 0,
                            'difficulty': 0.24117647058823527,
                            'update': 7326,
                            'interval': 4,
                            'ratingRecord': [
                              {
                                'rating': 'easy',
                                'time': 1579703110878
                              }
                            ]
                          },
                          'expanded': true,
                          'parentId': 'ZH7YfWSq1WOxsxQ1ensV',
                          'subtitle': '^',
                          'title': 'match to the start'
                        },
                        {
                          'id': 'nHHDObSjLHBXaQU6sbtO',
                          'height': 54,
                          'editableValues': {
                            'orderAsChild': 1,
                            'difficulty': 0.24117647058823527,
                            'update': 7326,
                            'interval': 4,
                            'ratingRecord': [
                              {
                                'rating': 'easy',
                                'time': 1579703139206
                              }
                            ]
                          },
                          'expanded': true,
                          'parentId': 'ZH7YfWSq1WOxsxQ1ensV',
                          'subtitle': '$',
                          'title': 'match to the end'
                        }
                      ]
                    },
                    {
                      'id': '2xYSpsyOUNPfnmODelui',
                      'height': 27,

                      'expanded': true,
                      'parentId': 'PsS20JjvPNaYFjTrQAyL',
                      'subtitle': '',
                      'title': 'words',
                      'children': [
                        {
                          'id': 'vV675OwrQFbd4Ujm2L9r',
                          'height': 54,
                          'editableValues': {
                            'failStatus': 'solved',
                            'orderAsChild': 2,
                            'difficulty': 0.7705882352941176,
                            'update': 7326,
                            'interval': 3,
                            'ratingRecord': [
                              {
                                'rating': 'fail',
                                'time': 1579703171652
                              },
                              {
                                'rating': 'hard',
                                'time': 1579703361128
                              }
                            ]
                          },
                          'expanded': true,
                          'parentId': '2xYSpsyOUNPfnmODelui',
                          'subtitle': '\\b',
                          'title': 'match to the border of words',
                          'children': [
                            {
                              'id': 'clGpXiLAUZP0h0lh93QR',
                              'height': 54,
                              'editableValues': {
                                'failStatus': 'solved',
                                'orderAsChild': 0,
                                'difficulty': 0.7705882352941176,
                                'update': 7326,
                                'interval': 3,
                                'ratingRecord': [
                                  {
                                    'rating': 'fail',
                                    'time': 1579703182970
                                  },
                                  {
                                    'rating': 'hard',
                                    'time': 1579703361431
                                  }
                                ]
                              },
                              'expanded': true,
                              'parentId': 'vV675OwrQFbd4Ujm2L9r',
                              'subtitle': '\\B',
                              'title': 'reverse'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      'id': '26Kww59RskuTNbcfPAl4',
                      'height': 27,

                      'expanded': true,
                      'parentId': 'PsS20JjvPNaYFjTrQAyL',
                      'subtitle': '',
                      'title': 'Blank',
                      'children': [
                        {
                          'id': 'zFPBkqatGIGX1m3ufzTP',
                          'height': 27,

                          'expanded': true,
                          'parentId': '26Kww59RskuTNbcfPAl4',
                          'subtitle': '',
                          'title': 'Basic character',
                          'children': [
                            {
                              'id': 'mfg3f8ppxD3hirKtoFQe',
                              'height': 54,
                              'editableValues': {
                                'failStatus': 'solved',
                                'orderAsChild': 0,
                                'difficulty': 0.4529411764705883,
                                'update': 7326,
                                'interval': 4,
                                'ratingRecord': [
                                  {
                                    'rating': 'hard',
                                    'time': 1579703198050
                                  },
                                  {
                                    'rating': 'hard',
                                    'time': 1579703304486
                                  }
                                ]
                              },
                              'expanded': true,
                              'parentId': 'zFPBkqatGIGX1m3ufzTP',
                              'subtitle': '\\n',
                              'title': 'Line break'
                            },
                            {
                              'id': 'eIGrDFX6YvBaNuACCNpu',
                              'height': 54,
                              'editableValues': {
                                'failStatus': 'solved',
                                'orderAsChild': 1,
                                'difficulty': 0.4529411764705883,
                                'update': 7326,
                                'interval': 4,
                                'ratingRecord': [
                                  {
                                    'rating': 'hard',
                                    'time': 1579703220269
                                  },
                                  {
                                    'rating': 'hard',
                                    'time': 1579703304790
                                  }
                                ]
                              },
                              'expanded': true,
                              'parentId': 'zFPBkqatGIGX1m3ufzTP',
                              'subtitle': '\\r',
                              'title': 'Carriage return'
                            },
                            {
                              'id': '4vSQ2UUzydhD5CbbVWNj',
                              'height': 54,
                              'editableValues': {
                                'failStatus': 'solved',
                                'orderAsChild': 2,
                                'difficulty': 0.4529411764705883,
                                'update': 7326,
                                'interval': 4,
                                'ratingRecord': [
                                  {
                                    'rating': 'hard',
                                    'time': 1579703233421
                                  },
                                  {
                                    'rating': 'hard',
                                    'time': 1579703305080
                                  }
                                ]
                              },
                              'expanded': true,
                              'parentId': 'zFPBkqatGIGX1m3ufzTP',
                              'subtitle': '\\t',
                              'title': 'Tab'
                            },
                            {
                              'id': 'qiKQd0CBNo9SMoQ53raj',
                              'height': 54,
                              'editableValues': {
                                'failStatus': 'solved',
                                'orderAsChild': 3,
                                'difficulty': 0.4529411764705883,
                                'update': 7326,
                                'interval': 4,
                                'ratingRecord': [
                                  {
                                    'rating': 'hard',
                                    'time': 1579703266521
                                  },
                                  {
                                    'rating': 'hard',
                                    'time': 1579703305356
                                  }
                                ]
                              },
                              'expanded': true,
                              'parentId': 'zFPBkqatGIGX1m3ufzTP',
                              'subtitle': '\\s',
                              'title': 'match to the all blank characters',
                              'children': [
                                {
                                  'id': '9Kxz4476jxSGovDLn5Kg',
                                  'height': 54,
                                  'editableValues': {
                                    'failStatus': 'solved',
                                    'orderAsChild': 0,
                                    'difficulty': 0.4529411764705883,
                                    'update': 7326,
                                    'interval': 4,
                                    'ratingRecord': [
                                      {
                                        'rating': 'hard',
                                        'time': 1579703266765
                                      },
                                      {
                                        'rating': 'hard',
                                        'time': 1579703305624
                                      }
                                    ]
                                  },
                                  'expanded': true,
                                  'parentId': 'qiKQd0CBNo9SMoQ53raj',
                                  'subtitle': '\\S',
                                  'title': 'reverse'
                                }
                              ]
                            }
                          ]
                        },
                        {
                          'id': 'ysdTo8sHNS0M7Hb9tqhE',
                          'height': 27,

                          'expanded': true,
                          'parentId': '26Kww59RskuTNbcfPAl4',
                          'subtitle': '',
                          'title': 'Applications',
                          'children': [
                            {
                              'id': '3bIGtziKH7814bNxPiFR',
                              'height': 27,

                              'expanded': true,
                              'parentId': 'ysdTo8sHNS0M7Hb9tqhE',
                              'subtitle': '',
                              'title': 'End of line',
                              'children': [
                                {
                                  'id': 'zPmLlVpedUDxLVfGgmkE',
                                  'height': 54,
                                  'editableValues': {
                                    'failStatus': 'solved',
                                    'orderAsChild': 0,
                                    'difficulty': 0.4529411764705883,
                                    'update': 7326,
                                    'interval': 4,
                                    'ratingRecord': [
                                      {
                                        'rating': 'hard',
                                        'time': 1579703290725
                                      },
                                      {
                                        'rating': 'hard',
                                        'time': 1579703384029
                                      }
                                    ]
                                  },
                                  'expanded': true,
                                  'parentId': '3bIGtziKH7814bNxPiFR',
                                  'subtitle': '\\r\\n',
                                  'title': 'window'
                                },
                                {
                                  'id': 'GXM7MrZEjtAfq7QEmSng',
                                  'height': 54,
                                  'editableValues': {
                                    'failStatus': 'solved',
                                    'orderAsChild': 1,
                                    'difficulty': 0.4529411764705883,
                                    'update': 7327,
                                    'interval': 2,
                                    'ratingRecord': [
                                      {
                                        'rating': 'hard',
                                        'time': 1579716383868
                                      },
                                      {
                                        'rating': 'hard',
                                        'time': 1579767339034
                                      }
                                    ]
                                  },
                                  'expanded': true,
                                  'parentId': '3bIGtziKH7814bNxPiFR',
                                  'subtitle': '\\n',
                                  'title': 'UNIX & Linux'
                                }
                              ]
                            },
                            {
                              'id': 'vKCh0rcQ93GqhSKtjdXA',
                              'height': 27,

                              'expanded': true,
                              'parentId': 'ysdTo8sHNS0M7Hb9tqhE',
                              'subtitle': '',
                              'title': 'Blank line',
                              'children': [
                                {
                                  'id': 'q6l1945zf3V8V0DHXaus',
                                  'height': 54,
                                  'editableValues': {
                                    'failStatus': 'solved',
                                    'orderAsChild': 0,
                                    'difficulty': 0.4529411764705883,
                                    'update': 7326,
                                    'interval': 4,
                                    'ratingRecord': [
                                      {
                                        'rating': 'hard',
                                        'time': 1579703317035
                                      },
                                      {
                                        'rating': 'hard',
                                        'time': 1579703400400
                                      }
                                    ]
                                  },
                                  'expanded': true,
                                  'parentId': 'vKCh0rcQ93GqhSKtjdXA',
                                  'subtitle': '\\r\\n\\r\\n',
                                  'title': 'window'
                                },
                                {
                                  'id': 'V6IeaGbWoTh2TlBjfhDd',
                                  'height': 54,
                                  'editableValues': {
                                    'failStatus': 'solved',
                                    'orderAsChild': 1,
                                    'difficulty': 0.4529411764705883,
                                    'update': 7327,
                                    'interval': 2,
                                    'ratingRecord': [
                                      {
                                        'rating': 'hard',
                                        'time': 1579716366634
                                      },
                                      {
                                        'rating': 'hard',
                                        'time': 1579767369322
                                      }
                                    ]
                                  },
                                  'expanded': true,
                                  'parentId': 'vKCh0rcQ93GqhSKtjdXA',
                                  'subtitle': '\\n\\n',
                                  'title': 'UNIX & Linux'
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  'id': 'toMTED5IxqSUv51Fztnn',
                  'height': 27,

                  'expanded': true,
                  'parentId': 'ylcErEplbNYEftPehNch',
                  'subtitle': '',
                  'title': 'subexpression',
                  'children': [
                    {
                      'id': '3VihK0CMtkADmOBBXnmC',
                      'height': 54,
                      'editableValues': {
                        'failStatus': 'solved',
                        'orderAsChild': -1,
                        'difficulty': 0.4529411764705883,
                        'update': 7327,
                        'interval': 2,
                        'ratingRecord': [
                          {
                            'rating': 'hard',
                            'time': 1579767056734
                          },
                          {
                            'rating': 'hard',
                            'time': 1579767229620
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': 'toMTED5IxqSUv51Fztnn',
                      'subtitle': '1.  To tie metacharacters after grouping together\n2. Left and right base when writing |\n3. backreferences',
                      'title': 'usage 3'
                    },
                    {
                      'id': 'bgLwcXcTcJiFeP2sy5mL',
                      'height': 54,
                      'editableValues': {
                        'failStatus': 'solved',
                        'orderAsChild': 0,
                        'difficulty': 0.4529411764705883,
                        'update': 7326,
                        'interval': 4,
                        'ratingRecord': [
                          {
                            'rating': 'hard',
                            'time': 1579703026953
                          },
                          {
                            'rating': 'hard',
                            'time': 1579703080583
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': 'toMTED5IxqSUv51Fztnn',
                      'subtitle': '()',
                      'title': 'character'
                    },
                    {
                      'id': 'pUDT68GnLuaz2bNszd6z',
                      'height': 54,
                      'editableValues': {
                        'failStatus': 'solved',
                        'orderAsChild': 1,
                        'difficulty': 0.4529411764705883,
                        'update': 7326,
                        'interval': 4,
                        'ratingRecord': [
                          {
                            'rating': 'hard',
                            'time': 1579703029330
                          },
                          {
                            'rating': 'hard',
                            'time': 1579703102935
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': 'toMTED5IxqSUv51Fztnn',
                      'subtitle': '$number',
                      'title': 'refer',
                      'children': [
                        {
                          'id': 'kls7vo41wKXxC8FDEV4Y',
                          'height': 54,
                          'editableValues': {
                            'failStatus': 'solved',
                            'orderAsChild': 0,
                            'difficulty': 0.4529411764705883,
                            'update': 7327,
                            'interval': 2,
                            'ratingRecord': [
                              {
                                'rating': 'hard',
                                'time': 1579767056758
                              },
                              {
                                'rating': 'hard',
                                'time': 1579767229624
                              }
                            ]
                          },
                          'expanded': true,
                          'parentId': 'pUDT68GnLuaz2bNszd6z',
                          'subtitle': 'points to a string matching the pattern in number-th ()',
                          'title': 'meaning of number'
                        },
                        {
                          'id': '46cP1M9BDzs1rPTlmvfn',
                          'height': 54,
                          'editableValues': {
                            'failStatus': 'solved',
                            'orderAsChild': 1,
                            'difficulty': 0.4529411764705883,
                            'update': 7327,
                            'interval': 2,
                            'ratingRecord': [
                              {
                                'rating': 'hard',
                                'time': 1579767056770
                              },
                              {
                                'rating': 'hard',
                                'time': 1579767229625
                              }
                            ]
                          },
                          'expanded': true,
                          'parentId': 'pUDT68GnLuaz2bNszd6z',
                          'subtitle': 'All the expression',
                          'title': '$0'
                        }
                      ]
                    }
                  ]
                },
                {
                  'id': 'anipwkywNeReIVzBr8JT',
                  'height': 54,
                  'editableValues': {
                    'failStatus': 'solved',
                    'orderAsChild': 6,
                    'difficulty': 0.6058823529411765,
                    'update': 7327,
                    'interval': 3,
                    'ratingRecord': [
                      {
                        'rating': 'hard',
                        'time': 1579766572147
                      },
                      {
                        'rating': 'hard',
                        'time': 1579766813150
                      }
                    ]
                  },
                  'expanded': true,
                  'parentId': 'ylcErEplbNYEftPehNch',
                  'subtitle': 'Used to find the exact match point, but not part of the real match',
                  'title': 'lookaround',
                  'children': [
                    {
                      'id': 'oHJ5cOcTvQCOvpPzYeoU',
                      'height': 54,
                      'editableValues': {
                        'failStatus': 'solved',
                        'orderAsChild': 0,
                        'difficulty': 0.7705882352941176,
                        'update': 7326,
                        'interval': 3,
                        'ratingRecord': [
                          {
                            'rating': 'fail',
                            'time': 1579702977687
                          },
                          {
                            'rating': 'hard',
                            'time': 1579703166902
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': 'anipwkywNeReIVzBr8JT',
                      'subtitle': '(?=something)',
                      'title': 'lookahead',
                      'children': [
                        {
                          'id': 'ZXKgYgFzivFhybag02QR',
                          'height': 54,
                          'editableValues': {
                            'failStatus': 'solved',
                            'orderAsChild': 0,
                            'difficulty': 0.7705882352941176,
                            'update': 7326,
                            'interval': 3,
                            'ratingRecord': [
                              {
                                'rating': 'fail',
                                'time': 1579702977847
                              },
                              {
                                'rating': 'hard',
                                'time': 1579703284107
                              }
                            ]
                          },
                          'expanded': true,
                          'parentId': 'oHJ5cOcTvQCOvpPzYeoU',
                          'subtitle': '(?!something)',
                          'title': 'negative'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              'id': 'snaCgbnlPIkHkTYAlQfC',
              'height': 27,

              'expanded': true,
              'parentId': 'zSrhu9jHBifl1SUbtzCk',
              'subtitle': '',
              'title': 'tips',
              'children': [
                {
                  'id': 'CWArXHQ7V2N0Uf5a1D5S',
                  'height': 54,
                  'editableValues': {
                    'failStatus': 'solved',
                    'orderAsChild': 0,
                    'difficulty': 0.4529411764705883,
                    'update': 7329,
                    'interval': 4,
                    'ratingRecord': [
                      {
                        'rating': 'hard',
                        'time': 1579766794743
                      },
                      {
                        'rating': 'hard',
                        'time': 1579766956812
                      },
                      {
                        'rating': 'normal',
                        'time': 1579906030110
                      }
                    ]
                  },
                  'expanded': true,
                  'parentId': 'snaCgbnlPIkHkTYAlQfC',
                  'subtitle': 'Use [] even with one character, followed by metacharacters',
                  'title': 'Set when writing metacharacters',
                  'children': [
                    {
                      'id': 'OCugXxZD2mst7aRlcX3Y',
                      'height': 54,
                      'editableValues': {
                        'failStatus': 'solved',
                        'orderAsChild': 0,
                        'difficulty': 0.3941176470588236,
                        'update': 7329,
                        'interval': 5,
                        'ratingRecord': [
                          {
                            'rating': 'hard',
                            'time': 1579766857469
                          },
                          {
                            'rating': 'hard',
                            'time': 1579766956816
                          },
                          {
                            'rating': 'easy',
                            'time': 1579906053587
                          }
                        ]
                      },
                      'expanded': true,
                      'parentId': 'CWArXHQ7V2N0Uf5a1D5S',
                      'subtitle': 'To ensure exactly where the following metacharacters apply',
                      'title': 'Why?'
                    }
                  ]
                },
                {
                  'id': 'OuutsNLWYJ9f1pHbm4ow',
                  'height': 54,
                  'editableValues': {
                    'failStatus': 'solved',
                    'orderAsChild': 1,
                    'difficulty': 0.3941176470588236,
                    'update': 7329,
                    'interval': 5,
                    'ratingRecord': [
                      {
                        'rating': 'hard',
                        'time': 1579766801540
                      },
                      {
                        'rating': 'hard',
                        'time': 1579766956821
                      },
                      {
                        'rating': 'easy',
                        'time': 1579906037931
                      }
                    ]
                  },
                  'expanded': true,
                  'parentId': 'snaCgbnlPIkHkTYAlQfC',
                  'subtitle': 'Write that \\ /',
                  'title': '/'
                },
                {
                  'id': 'GG8yWBfVysmlt55PG254',
                  'height': 54,
                  'editableValues': {
                    'failStatus': 'solved',
                    'orderAsChild': 2,
                    'difficulty': 0.4529411764705883,
                    'update': 7329,
                    'interval': 4,
                    'ratingRecord': [
                      {
                        'rating': 'hard',
                        'time': 1579766820600
                      },
                      {
                        'rating': 'hard',
                        'time': 1579766956825
                      },
                      {
                        'rating': 'normal',
                        'time': 1579906045114
                      }
                    ]
                  },
                  'expanded': true,
                  'parentId': 'snaCgbnlPIkHkTYAlQfC',
                  'subtitle': "It's easy to match what you're aiming for\nDifficult to make other things not to match",
                  'title': 'Difficult part'
                }
              ]
            }
          ]
        }
      ],
      'doesIndexSwap': false
    },
    {
      'id': 'Ul6ROJLJ5f2x60izc05b',
      'height': 56,

      'expanded': false,
      'parentId': 'rootNode',
      'subtitle': '',
      'title': 'Analytics',
      'children': [
        {
          'id': 'Vibuzqk6SDHMl0kNMpDX',
          'height': 54,

          'expanded': true,
          'parentId': 'Ul6ROJLJ5f2x60izc05b',
          'subtitle': 'document that clarify 1) what events to track, 2) where those events need to go in the code base, 3) why those events are necessary from a business perspective',
          'title': 'Tracking Plan',
          'children': [
            {
              'id': 'C3QRO5U48uYHEpuw54rQ',
              'height': 54,

              'expanded': true,
              'parentId': 'Vibuzqk6SDHMl0kNMpDX',
              'subtitle': "Data that doesn't fit in here can be automatically blocked to prevent data from getting dirty.",
              'title': 'usage'
            }
          ]
        },
        {
          'id': 'aL1QDzFtNf87r8CZOEBX',
          'height': 54,

          'expanded': true,
          'parentId': 'Ul6ROJLJ5f2x60izc05b',
          'subtitle': 'Initially, to measure the product-market fit, retention->\nacquisition  for scaling -> activating',
          'title': 'What you need to track step by step'
        },
        {
          'id': 'OAh41eDy4dIZBXlu4iUG',
          'height': 27,

          'expanded': true,
          'parentId': 'Ul6ROJLJ5f2x60izc05b',
          'subtitle': '',
          'title': 'qualitative vs quantitative',
          'children': [
            {
              'id': 'YdQNfEsrVDDM2W3iML4G',
              'height': 54,

              'expanded': true,
              'parentId': 'OAh41eDy4dIZBXlu4iUG',
              'subtitle': 'development or when there are not enough users',
              'title': 'When to use qualitative data tool'
            }
          ]
        },
        {
          'id': 'pj1uowyI1oYHwl2LPB4t',
          'height': 27,

          'expanded': true,
          'parentId': 'Ul6ROJLJ5f2x60izc05b',
          'subtitle': '',
          'title': 'Event Tracking',
          'children': [
            {
              'id': 'aE4jCtnSJeuW1vHprhZ0',
              'height': 27,

              'expanded': true,
              'parentId': 'pj1uowyI1oYHwl2LPB4t',
              'subtitle': '',
              'title': 'API',
              'children': [
                {
                  'id': 'StkCjSDPOce95J8UKlxS',
                  'height': 27,

                  'expanded': true,
                  'parentId': 'aE4jCtnSJeuW1vHprhZ0',
                  'subtitle': '',
                  'title': '.track()',
                  'children': [
                    {
                      'id': 'nOBInkDJOl3AepdZBQ5u',
                      'height': 54,

                      'expanded': true,
                      'parentId': 'StkCjSDPOce95J8UKlxS',
                      'subtitle': '1) userId\n2) event\n3) properties\n4) timestamp',
                      'title': 'it tracks 4'
                    }
                  ]
                }
              ]
            },
            {
              'id': 'mV4p2YcPaZY3wrwtjEMt',
              'height': 54,

              'expanded': true,
              'parentId': 'pj1uowyI1oYHwl2LPB4t',
              'subtitle': 'less is more',
              'title': 'principles'
            },
            {
              'id': 'IivHku6VxKoCITjdeKFQ',
              'height': 54,

              'expanded': true,
              'parentId': 'pj1uowyI1oYHwl2LPB4t',
              'subtitle': 'Many times, you can use fewer event names to answer the same thing, especially when you include relevant data in the properties',
              'title': 'cut down'
            },
            {
              'id': 'T9lKk1K4xNHoDhbJdmvw',
              'height': 54,

              'expanded': true,
              'parentId': 'pj1uowyI1oYHwl2LPB4t',
              'subtitle': "1. Don't create event names dynamically\n2. don't track lower-level properties\n3. Don't put multiple events in one track() call",
              'title': "Don't do it"
            },
            {
              'id': 'btXqpCtAo63CctOBMtI1',
              'height': 54,

              'expanded': true,
              'parentId': 'pj1uowyI1oYHwl2LPB4t',
              'subtitle': '1. every event helps you answer a question\n2. Test to see if the event you choose to track is actually tracked when it triggered',
              'title': 'make sure'
            },
            {
              'id': 'VWregAENB4umwAGPo5PA',
              'height': 54,

              'expanded': true,
              'parentId': 'pj1uowyI1oYHwl2LPB4t',
              'subtitle': 'core customer lifecycle to construct funnel',
              'title': 'start with'
            },
            {
              'id': 'yEviB6pW5NxXAh6QSMh1',
              'height': 54,

              'expanded': true,
              'parentId': 'pj1uowyI1oYHwl2LPB4t',
              'subtitle': "you feel they're missing",
              'title': 'only add events as'
            }
          ]
        },
        {
          'id': 'pn3leKa9IwPmCzY1gTN4',
          'height': 27,

          'expanded': true,
          'parentId': 'Ul6ROJLJ5f2x60izc05b',
          'subtitle': '',
          'title': 'tips',
          'children': [
            {
              'id': '5ZXegY2SDJHUYKLgRpkT',
              'height': 54,

              'expanded': true,
              'parentId': 'pn3leKa9IwPmCzY1gTN4',
              'subtitle': 'Break down the main metric into multiple metrics',
              'title': 'main metric'
            }
          ]
        },
        {
          'id': 'pPYlJuFeh0YmWsBJ2b1a',
          'height': 27,

          'expanded': true,
          'parentId': 'Ul6ROJLJ5f2x60izc05b',
          'subtitle': '',
          'title': 'attribution model',
          'children': [
            {
              'id': 'RfsXIHZWODUYQUthvmwY',
              'height': 54,

              'expanded': true,
              'parentId': 'pPYlJuFeh0YmWsBJ2b1a',
              'subtitle': 'Checking only the channel the user last went through',
              'title': 'last touch'
            },
            {
              'id': 'G3VKfzEoONaJnm9xV9RU',
              'height': 54,

              'expanded': true,
              'parentId': 'pPYlJuFeh0YmWsBJ2b1a',
              'subtitle': 'Check only the first user interacted',
              'title': 'first touch'
            },
            {
              'id': 'BLNteERZZ4jqe99T8VEc',
              'height': 54,

              'expanded': true,
              'parentId': 'pPYlJuFeh0YmWsBJ2b1a',
              'subtitle': 'Give the same score to the channels the user has gone through',
              'title': 'linear'
            },
            {
              'id': 'iZSzJ4yz18g2kSBz6MDX',
              'height': 54,

              'expanded': true,
              'parentId': 'pPYlJuFeh0YmWsBJ2b1a',
              'subtitle': 'Decay and score points according to the last time there from the channels that the user went through',
              'title': 'time decay'
            },
            {
              'id': 'Ivp1WsOU55zO2SVTiNOM',
              'height': 27,

              'expanded': true,
              'parentId': 'pPYlJuFeh0YmWsBJ2b1a',
              'subtitle': '',
              'title': 'custom',
              'children': [
                {
                  'id': '9CsAvXDKY8ClAU8vskLL',
                  'height': 54,

                  'expanded': true,
                  'parentId': 'Ivp1WsOU55zO2SVTiNOM',
                  'subtitle': 'U shaped model (scores first and last many points)',
                  'title': 'Many companies use'
                },
                {
                  'id': 'p7tnGpE4BtvrPXh9FbfM',
                  'height': 54,

                  'expanded': true,
                  'parentId': 'Ivp1WsOU55zO2SVTiNOM',
                  'subtitle': 'Take an existing weighted model and adjust it incrementally',
                  'title': 'to make'
                },
                {
                  'id': '8KVLj7oNq6wsUnIE6Jgx',
                  'height': 54,

                  'expanded': true,
                  'parentId': 'Ivp1WsOU55zO2SVTiNOM',
                  'subtitle': 'As the situation changes, the model will evolve as well, so the effort to make the model perfect at any given point is of little value.',
                  'title': 'For the perfect model'
                }
              ]
            }
          ]
        },
        {
          'id': 'vO8q1wcWcJtgHxfJd2O0',
          'height': 27,

          'expanded': true,
          'parentId': 'Ul6ROJLJ5f2x60izc05b',
          'subtitle': '',
          'title': 'Glossary',
          'children': [
            {
              'id': '9t2KaQ5cbSnroQ6eqhgP',
              'height': 54,

              'expanded': true,
              'parentId': 'vO8q1wcWcJtgHxfJd2O0',
              'subtitle': 'acquisition, activation, retention, revenue, referral',
              'title': 'Pirate metrics AARRR',
              'children': [
                {
                  'id': 'jO2Z4YwT3vBfXnWvS8Zr',
                  'height': 54,

                  'expanded': true,
                  'parentId': '9t2KaQ5cbSnroQ6eqhgP',
                  'subtitle': "a product's full funnel categories",
                  'title': 'define'
                }
              ]
            },
            {
              'id': 'l4nhdVEFpbb421GtIrE0',
              'height': 54,

              'expanded': true,
              'parentId': 'vO8q1wcWcJtgHxfJd2O0',
              'subtitle': 'key performance indicator',
              'title': 'KPI'
            },
            {
              'id': 'CsuQpps4GjTtURmw7yFI',
              'height': 54,

              'expanded': true,
              'parentId': 'vO8q1wcWcJtgHxfJd2O0',
              'subtitle': 'life time value',
              'title': 'LTV'
            },
            {
              'id': '0XyPPsHOoZYXoPKNAGBe',
              'height': 54,

              'expanded': true,
              'parentId': 'vO8q1wcWcJtgHxfJd2O0',
              'subtitle': 'objectives and key results',
              'title': 'OKR'
            }
          ]
        },
        {
          'id': 'TCt3tMC69HKmOAwIKtMy',
          'height': 27,

          'expanded': true,
          'parentId': 'Ul6ROJLJ5f2x60izc05b',
          'subtitle': '',
          'title': 'customer journey',
          'children': [
            {
              'id': 'Dgmbp7D8HYdY3dQOLjvf',
              'height': 54,

              'expanded': true,
              'parentId': 'TCt3tMC69HKmOAwIKtMy',
              'subtitle': 'the moment in which user first begin to understand the value of the product',
              'title': 'aha moment'
            },
            {
              'id': 'PKcOWFXcJfb5ih6ghxuV',
              'height': 54,

              'expanded': true,
              'parentId': 'TCt3tMC69HKmOAwIKtMy',
              'subtitle': 'when users begin to truly rely on the product',
              'title': 'habit moment'
            },
            {
              'id': 'yb5g4l9T1aUScWE9pQve',
              'height': 54,

              'expanded': true,
              'parentId': 'TCt3tMC69HKmOAwIKtMy',
              'subtitle': 'Define which tasks are for aha moment and habit moment and make the users go there',
              'title': 'application'
            }
          ]
        },
        {
          'id': 'RC64tNhpTRwwTKFCPlq7',
          'height': 27,

          'expanded': true,
          'parentId': 'Ul6ROJLJ5f2x60izc05b',
          'subtitle': '',
          'title': 'Metric',
          'children': [
            {
              'id': 'sfV6CNZO9eB7dvU7ITUL',
              'height': 54,

              'expanded': true,
              'parentId': 'RC64tNhpTRwwTKFCPlq7',
              'subtitle': '1.  Measure rates instead of totals\n2. Choose metrics with clear owners (what part is associated with that metric)\n3. Choose a time window',
              'title': 'How should I set up? 3',
              'children': [
                {
                  'id': 'dS1xPd3pnkyenoBHeyko',
                  'height': 54,

                  'expanded': true,
                  'parentId': 'sfV6CNZO9eB7dvU7ITUL',
                  'subtitle': 'If it is too small, it is noisy and if it is too big, the learning will be slow',
                  'title': 'trade off in setting the time window'
                },
                {
                  'id': 'hfIiOfWo0DjiJ92N4Vf1',
                  'height': 54,

                  'expanded': true,
                  'parentId': 'sfV6CNZO9eB7dvU7ITUL',
                  'subtitle': 'goal',
                  'title': 'Exception for setting rate instead of total'
                }
              ]
            },
            {
              'id': 'gj64dawY1IIPP2xm0AT9',
              'height': 54,

              'expanded': true,
              'parentId': 'RC64tNhpTRwwTKFCPlq7',
              'subtitle': '1. Decide what you are trying to learn\n2. Find out how to measure it build experiment\n3. build experiment',
              'title': 'Setting process'
            }
          ]
        },
        {
          'id': 'dGWe4QXeS8Abv2nohAqT',
          'height': 54,

          'expanded': true,
          'parentId': 'Ul6ROJLJ5f2x60izc05b',
          'subtitle': "A naming convention for maintaining data consistency, in which the name of an object followed by the user's action on that object is the name of the event.",
          'title': 'The Object-Action Framework'
        },
        {
          'id': '4fNCZp0SU9M1sRNT5eXI',
          'height': 54,

          'expanded': true,
          'parentId': 'Ul6ROJLJ5f2x60izc05b',
          'subtitle': '1. Measure product-market fit\n2. understand product funnel\n3. personalized campaigns\n4. gather targeted user feedback\n5. customer service',
          'title': 'Where to use gathered data 5'
        },
        {
          'id': 'MK5ZA8ohZ62OKxbND5Dm',
          'height': 54,

          'expanded': true,
          'parentId': 'Ul6ROJLJ5f2x60izc05b',
          'subtitle': 'When companies start using lots of tools at different times, often they become cluttered with too much data and duplicate events with different names.',
          'title': 'Data inconsistencies',
          'children': [
            {
              'id': 'WixEvnasRr7ZiwEX7AJx',
              'height': 54,

              'expanded': true,
              'parentId': 'MK5ZA8ohZ62OKxbND5Dm',
              'subtitle': '1. Choose the most important metric and choose what to track and which tool to use\n2. Track new events only when you really need them',
              'title': 'What should I do'
            }
          ]
        },
        {
          'id': '4YsvKJzy1qItIOBJvBVk',
          'height': 27,

          'expanded': true,
          'parentId': 'Ul6ROJLJ5f2x60izc05b',
          'subtitle': '',
          'title': 'Measure product-market fit',
          'children': [
            {
              'id': 'e3diccihBlKdMJjJgFoy',
              'height': 54,

              'expanded': true,
              'parentId': '4YsvKJzy1qItIOBJvBVk',
              'subtitle': 'Retention cohorts',
              'title': 'what to measure',
              'children': [
                {
                  'id': '3sJIJuXKTBEH4ekhbnf6',
                  'height': 54,

                  'expanded': true,
                  'parentId': 'e3diccihBlKdMJjJgFoy',
                  'subtitle': 'Measuring through events that symbolize people using the product and the ideal frequency for that event',
                  'title': 'How?'
                }
              ]
            }
          ]
        }
      ],
      'doesIndexSwap': false
    }
  ]
)
export const MosaicFor2 = '{ "id": "nqExVDb8", "path": [] }'

export const TreeDataFor4 = [
  {
    'id': 'qaXq9hw0TRlUbXz1wf2S',
    'height': 28,
    'expanded': true,
    'parentId': 'rootNode',
    'subtitle': '',
    'title': 'LearnObit',
    'children': [
      {
        'id': '9Gamj0wU1pPhp55umCiy',
        'height': 28,
        'expanded': true,
        'parentId': 'qaXq9hw0TRlUbXz1wf2S',
        'subtitle': '',
        'title': 'Organs',
        'doesIndexSwap': false,
        isUploadType2: true,
        uploadType2Id: 'exampleUploadType2Id'
      },
      {
        'id': '9Gamj0wU1pPhp55umCi',
        'height': 28,
        'expanded': true,
        'parentId': 'qaXq9hw0TRlUbXz1wf2S',
        'subtitle': '',
        'title': 'Trifle In Pyjamas lead sheet',
        'doesIndexSwap': false,
        isUploadType2: true,
        uploadType2Id: 'exampleUploadType2Id2'
      }
    ],
    'doesIndexSwap': false
  }
]

export const TreeDataFor5 = [
  {
    'id': 'qaXq9hw0TRlUbXz1wf2S',
    'height': 28,
    'expanded': true,
    'parentId': 'rootNode',
    'subtitle': '',
    'title': 'LearnObit',
    'children': [
      {
        'id': '9Gamj0wU1pPhp55umCiy',
        'height': 28,
        'expanded': true,
        'parentId': 'qaXq9hw0TRlUbXz1wf2S',
        'subtitle': '',
        'title': 'Hotkeys',
        'doesIndexSwap': false,
        isSpreadsheet: true,
        spreadsheetId: 'exampleSpreadsheetId'
      }
    ],
    'doesIndexSwap': false
  }
]
